// Generated by AvenyModelEditor

import { IClientSubSystemModel } from '../../Types/ClientModelTypes';
import { TEDSelectionOperator as T} from '../../globalQueryTypes';

const AR: IClientSubSystemModel = {
  Code: 'AR',
  DisplayLabel: 'Anläggningsredovisning',
  BusinessModels: {
    ARTillgangFordelning: {
      CollectionName: 'ARTillgangFordelning',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'TillgangFordelning',
        Abstract: false,
        SOLabel: 'Anläggning, fördelning',
        SOGLabel: 'Anläggning, fördelning',
        SBLabel: 'Anläggning, fördelning',
        SBGLabel: 'Anläggning, fördelning',
        POLabel: 'Anläggning, fördelning',
        POGLabel: 'Anläggning, fördelning',
        PBLabel: 'Anläggning, fördelning',
        PBGLabel: 'Anläggning, fördelning',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Anläggning, fördelning primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Anläggning, fördelning versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Anläggning, fördelning fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FORDELA_AVSKR_DEBET: {
          AttributeName: 'FORDELA_AVSKR_DEBET',
          DisplayLabel: 'Fördela avskrivning',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FORDELA_INTRANTA_DEBET: {
          AttributeName: 'FORDELA_INTRANTA_DEBET',
          DisplayLabel: 'Fördela internränta',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FORDELA_AVSKR_DEBET_ID: {
          AttributeName: 'FORDELA_AVSKR_DEBET_ID',
          DisplayLabel: 'Fördelningsmall avskr id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FORDELA_INTRANTA_DEBET_ID: {
          AttributeName: 'FORDELA_INTRANTA_DEBET_ID',
          DisplayLabel: 'Fördela internränta id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Kodplan: {
          AssociationName: 'Kodplan',
          DisplayLabel: 'Kodplan',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontoplan',
          AssociatedComponentName: 'Kontoplan',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Tillgang: {
          AssociationName: 'Tillgang',
          DisplayLabel: 'Anläggningstillgång',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARTillgang',
          AssociatedComponentName: 'Tillgang',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        FordelningsmallAvskrDebet: {
          AssociationName: 'FordelningsmallAvskrDebet',
          DisplayLabel: 'Fördelningsmall, avskrivning',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKAutomatkonteringar',
          AssociatedComponentName: 'FordelningsmallAutomatkontering',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        FordelningsmallIntrantaDebet: {
          AssociationName: 'FordelningsmallIntrantaDebet',
          DisplayLabel: 'Fördelningsmall, internränta',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKAutomatkonteringar',
          AssociatedComponentName: 'FordelningsmallAutomatkontering',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    ARAnlGrupp: {
      CollectionName: 'ARAnlGrupp',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '3005']]),
      RootType: {
        TypeValue: 'AnlGrupp',
        Abstract: false,
        SOLabel: 'Anläggningsgrupp',
        SOGLabel: 'Anläggningsgrupp',
        SBLabel: 'Anläggningsgruppen',
        SBGLabel: 'Anläggningsgruppen',
        POLabel: 'Anläggningsgrupper',
        POGLabel: 'Anläggningsgrupper',
        PBLabel: 'Anläggningsgrupperna',
        PBGLabel: 'Anläggningsgrupperna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Anläggningsgruppen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Anläggningsgruppen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Anläggningsgruppen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Anläggningsgruppen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        AVST_INVKONTO: {
          AttributeName: 'AVST_INVKONTO',
          DisplayLabel: 'Avstämning  mellan anläggningstillgångar och investeringskonton',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        KBAvskrKontoKred: {
          AttributeName: 'KBAvskrKontoKred',
          DisplayLabel: 'KBAvskrKontoKred',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ConstantValue', '-75;']]),
        },
        AvskrKontoKred: {
          AttributeName: 'AvskrKontoKred',
          DisplayLabel: 'Konteringsmall - Avskrivning kredit',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        KBAvskrKontoDeb: {
          AttributeName: 'KBAvskrKontoDeb',
          DisplayLabel: 'KBAvskrKontoDeb',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ConstantValue', '-76;']]),
        },
        AvskrKontoDeb: {
          AttributeName: 'AvskrKontoDeb',
          DisplayLabel: 'Konteringsmall - Avskrivning debet',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        KBInternRantaDeb: {
          AttributeName: 'KBInternRantaDeb',
          DisplayLabel: 'KBInternRantaDeb',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ConstantValue', '-77;']]),
        },
        InternRantaDeb: {
          AttributeName: 'InternRantaDeb',
          DisplayLabel: 'Konteringsmall - Internränta debet',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        KBInternRantaKred: {
          AttributeName: 'KBInternRantaKred',
          DisplayLabel: 'KBInternRantaKred',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ConstantValue', '-78;']]),
        },
        InternRantaKred: {
          AttributeName: 'InternRantaKred',
          DisplayLabel: 'Konteringsmall - Internränta kredit',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        RuleID: {
          AttributeName: 'RuleID',
          DisplayLabel: 'RuleID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        IDKOD: {
          AttributeName: 'IDKOD',
          DisplayLabel: 'ID-kod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 20,
        },
        ANVANDS_FOR: {
          AttributeName: 'ANVANDS_FOR',
          DisplayLabel: 'Används för',
          Hint: 'Anläggningstillgångar/Förbrukningsinventarier/Kyrkliga inventarier',
          DataType: 'Enum',
          EnumValues: new Map([['ANLAGGNINGSTILLGANGAR', 'Anläggningstillgångar'], ['FORBRUKNINGSINVENTARIER', 'Förbrukningsinventarier'], ['KYRKLIGA_INVENTARIER', 'Kyrkliga inventarier']]),
          EnumSortValues: new Map([['ANLAGGNINGSTILLGANGAR', 'A'], ['FORBRUKNINGSINVENTARIER', 'F'], ['KYRKLIGA_INVENTARIER', 'K']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANLAGGNINGSTILLGANGAR=Anläggningstillgångar;FORBRUKNINGSINVENTARIER=Förbrukningsinventarier;KYRKLIGA_INVENTARIER=Kyrkliga inventarier"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        AvskrkontoKred: {
          AssociationName: 'AvskrkontoKred',
          DisplayLabel: 'Avskrivningskonto kredit',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        AvskrkontoDeb: {
          AssociationName: 'AvskrkontoDeb',
          DisplayLabel: 'Avskrivningskonto debet',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        InternRantaDeb: {
          AssociationName: 'InternRantaDeb',
          DisplayLabel: 'Konto för internränta debet',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        InternRantaKred: {
          AssociationName: 'InternRantaKred',
          DisplayLabel: 'Konto för internränta kredit',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        HuvudRubrikAnlGrupp: {
          AssociationName: 'HuvudRubrikAnlGrupp',
          DisplayLabel: 'HuvudRubrik AnlGrupp',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'ARHuvudRubrikAnlGrupp',
          AssociatedComponentName: 'HuvudRubrikAnlGrupp',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        InvradUrval: {
          AssociationName: 'InvradUrval',
          DisplayLabel: 'Urval investeringsrader',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'ARAnlGruppInvUrval',
          AssociatedComponentName: 'AnlGruppInvUrval',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    ARAnlKat: {
      CollectionName: 'ARAnlKat',
      UDAEnabled: true,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '3004'], ['AllowEdit', '17001']]),
      RootType: {
        TypeValue: 'AnlKat',
        Abstract: false,
        SOLabel: 'Anläggningskategori',
        SOGLabel: 'Anläggningskategori',
        SBLabel: 'Anläggningskategorin',
        SBGLabel: 'Anläggningskategorin',
        POLabel: 'Anläggningskategorier',
        POGLabel: 'Anläggningskategorier',
        PBLabel: 'Anläggningskategorierna',
        PBGLabel: 'Anläggningskategorierna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Anläggningskategorin primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Anläggningskategorin versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Anläggningskategorin id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Anläggningskategorin fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AR_ANLKAT_ID: {
          AttributeName: 'AR_ANLKAT_ID',
          DisplayLabel: 'Kod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True;']]),
          Required: true,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True;']]),
          Required: true,
        },
        LEDTEXT1: {
          AttributeName: 'LEDTEXT1',
          DisplayLabel: 'Ledtext 1',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Ledtexter',
        },
        LEDTEXT2: {
          AttributeName: 'LEDTEXT2',
          DisplayLabel: 'Ledtext 2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Ledtexter',
        },
        LEDTEXT3: {
          AttributeName: 'LEDTEXT3',
          DisplayLabel: 'Ledtext 3',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Ledtexter',
        },
        LEDTEXT4: {
          AttributeName: 'LEDTEXT4',
          DisplayLabel: 'Ledtext 4',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Ledtexter',
        },
        LEDTEXT5: {
          AttributeName: 'LEDTEXT5',
          DisplayLabel: 'Ledtext 5',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Ledtexter',
        },
        LEDTEXT6: {
          AttributeName: 'LEDTEXT6',
          DisplayLabel: 'Ledtext 6',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Ledtexter',
        },
        LEDTEXT7: {
          AttributeName: 'LEDTEXT7',
          DisplayLabel: 'Ledtext 7',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Ledtexter',
        },
        LEDTEXT8: {
          AttributeName: 'LEDTEXT8',
          DisplayLabel: 'Ledtext 8',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Ledtexter',
        },
        NORMALAVSKRTID: {
          AttributeName: 'NORMALAVSKRTID',
          DisplayLabel: 'Normal avskr.tid',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        KodBenamning: {
          AttributeName: 'KodBenamning',
          DisplayLabel: 'Anläggningskategori',
          Hint: 'Anläggningskategori på formen kod : benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        KodBen: {
          AttributeName: 'KodBen',
          DisplayLabel: 'Kod och benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['ConditionShowValues', 'True;']]),
        },
        AKTIV: {
          AttributeName: 'AKTIV',
          DisplayLabel: 'Aktiv',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        AnvForFI: {
          AttributeName: 'AnvForFI',
          DisplayLabel: 'Används för förbrukningsinventarier',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Blob: {
          AssociationName: 'Blob',
          DisplayLabel: 'Blob',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'ARAnlKatBlob',
          AssociatedComponentName: 'AnlKatBlob',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: true,
          Properties: new Map([]),
        },
        Tillgangar: {
          AssociationName: 'Tillgangar',
          DisplayLabel: 'Anläggningstillgångar/Inventarier',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'ARTillgang',
          AssociatedComponentName: 'Tillgang',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    ARAnlKatBlob: {
      CollectionName: 'ARAnlKatBlob',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'AnlKatBlob',
        Abstract: false,
        SOLabel: '',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: '',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'ARAnlKatBlobs primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'ARAnlKatBlobs versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'ARAnlKatBlobs id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'ARAnlKatBlobs fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BESKRIVNING: {
          AttributeName: 'BESKRIVNING',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    ARTillgangLogg: {
      CollectionName: 'ARTillgangLogg',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'TillgangLogg',
        Abstract: false,
        SOLabel: 'Anläggningstillgång, logg',
        SOGLabel: 'Anläggningstillgång, loggs',
        SBLabel: 'Anläggningstillgång, loggen',
        SBGLabel: 'Anläggningstillgång, loggens',
        POLabel: 'Anläggningstillgång, loggar',
        POGLabel: 'Anläggningstillgång, loggars',
        PBLabel: 'Anläggningstillgång, loggarna',
        PBGLabel: 'Anläggningstillgång, loggarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Anläggningstillgång, loggens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Anläggningstillgång, loggens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Anläggningstillgång, loggens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Anläggningstillgång, loggens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TILLGANG_ID: {
          AttributeName: 'TILLGANG_ID',
          DisplayLabel: 'Tillgång, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LOPNR: {
          AttributeName: 'LOPNR',
          DisplayLabel: 'Löpnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        UPPR_LOPNR: {
          AttributeName: 'UPPR_LOPNR',
          DisplayLabel: 'Uppräkning, löpnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANDRINGSTYP: {
          AttributeName: 'ANDRINGSTYP',
          DisplayLabel: 'Typ av ändring',
          Hint: 'Avskrivningstid/Sammanslagning/Byte investeringskonto/Investering flyttad/Skattemässig avskrivningstid/Skattemässig ingående avskrivningstid/Hantera skattemässiga värden',
          DataType: 'Enum',
          EnumValues: new Map([['AVSKRIVNINGSTID', 'Avskrivningstid'], ['SAMMANSLAGNING', 'Sammanslagning'], ['BYTE_INVESTERINGSKONTO', 'Byte investeringskonto'], ['INVESTERING_FLYTTAD', 'Investering flyttad'], ['SKATTEMASSIG_AVSKRIVNINGSTID', 'Skattemässig avskrivningstid'], ['SKATTEMASSIG_INGAENDE_AVSKRIVNINGSTID', 'Skattemässig ingående avskrivningstid'], ['HANTERA_SKATTEMASSIGA_VARDEN', 'Hantera skattemässiga värden']]),
          EnumSortValues: new Map([['AVSKRIVNINGSTID', '1'], ['SAMMANSLAGNING', '2'], ['BYTE_INVESTERINGSKONTO', '3'], ['INVESTERING_FLYTTAD', '4'], ['SKATTEMASSIG_AVSKRIVNINGSTID', '5'], ['SKATTEMASSIG_INGAENDE_AVSKRIVNINGSTID', '6'], ['HANTERA_SKATTEMASSIGA_VARDEN', '7']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="AVSKRIVNINGSTID=Avskrivningstid;SAMMANSLAGNING=Sammanslagning;BYTE_INVESTERINGSKONTO=Byte investeringskonto;INVESTERING_FLYTTAD=Investering flyttad;SKATTEMASSIG_AVSKRIVNINGSTID=Skattemässig avskrivningstid;SKATTEMASSIG_INGAENDE_AVSKRIVNINGSTID=Skattemässig ingående avskrivningstid;HANTERA_SKATTEMASSIGA_VARDEN=Hantera skattemässiga värden"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Required: true,
        },
        EXTERN_LOGGTEXT: {
          AttributeName: 'EXTERN_LOGGTEXT',
          DisplayLabel: 'Loggtext',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        INTERN_LOGGTEXT: {
          AttributeName: 'INTERN_LOGGTEXT',
          DisplayLabel: 'Intern loggtext',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SIGNATUR: {
          AttributeName: 'SIGNATUR',
          DisplayLabel: 'Signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TID: {
          AttributeName: 'TID',
          DisplayLabel: 'Tid',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTime',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        BR_BOKF_DATUM: {
          AttributeName: 'BR_BOKF_DATUM',
          DisplayLabel: 'Bokföringsdatum, byte rubrik',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BR_FRAN_RUBRIK: {
          AttributeName: 'BR_FRAN_RUBRIK',
          DisplayLabel: 'Från rubrik',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BR_TILL_RUBRIK: {
          AttributeName: 'BR_TILL_RUBRIK',
          DisplayLabel: 'Till rubrik',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BR_BOKF_AR: {
          AttributeName: 'BR_BOKF_AR',
          DisplayLabel: 'Byte rubrik, bokf.år',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateYear',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BR_VER_NR: {
          AttributeName: 'BR_VER_NR',
          DisplayLabel: 'Byte rubrik, vernr',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        OmklassAnskaff: {
          AttributeName: 'OmklassAnskaff',
          DisplayLabel: 'Omklass, anskaffbelopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        OmklassAvskr: {
          AttributeName: 'OmklassAvskr',
          DisplayLabel: 'Omklass, avskr.belopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        OmklassNedskr: {
          AttributeName: 'OmklassNedskr',
          DisplayLabel: 'Omklass, nedskr.belopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        FLYTTAD_FRAN_TILLGANG_ID: {
          AttributeName: 'FLYTTAD_FRAN_TILLGANG_ID',
          DisplayLabel: 'Flyttad från anl.tillgång, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BR_SKV_ANSKAFFN: {
          AttributeName: 'BR_SKV_ANSKAFFN',
          DisplayLabel: 'Skattemässig omklassificering, anskaffningar',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BR_SKV_AVSKRIVN: {
          AttributeName: 'BR_SKV_AVSKRIVN',
          DisplayLabel: 'Skattemässig omklassificering, avskrivningar',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BR_SKV_NEDSKRIVN: {
          AttributeName: 'BR_SKV_NEDSKRIVN',
          DisplayLabel: 'Skattemässig omklassificering, nedskrivningar',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
      },
      Associations: {
        FranRubrik: {
          AssociationName: 'FranRubrik',
          DisplayLabel: 'Från rubrik',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARRubrik',
          AssociatedComponentName: 'Rubrik',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        TillRubrik: {
          AssociationName: 'TillRubrik',
          DisplayLabel: 'Till rubrik',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARRubrik',
          AssociatedComponentName: 'Rubrik',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Investering: {
          AssociationName: 'Investering',
          DisplayLabel: 'Investering',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARUpprakning',
          AssociatedComponentName: 'Upprakning',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        FlyttadFran: {
          AssociationName: 'FlyttadFran',
          DisplayLabel: 'Flyttad från anl.tillgång',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARTillgang',
          AssociatedComponentName: 'Tillgang',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    ARTillgang: {
      CollectionName: 'ARTillgang',
      UDAEnabled: true,
      UDNEnabled: true,
      Properties: new Map([['GroupAssociation', 'AnlGrupp'], ['USER_DEF_REPORT_ROUTINE', '3001'], ['AllowSelection', '17003']]),
      RootType: {
        TypeValue: 'Tillgang',
        Abstract: false,
        SOLabel: 'Anläggningstillgång/Inventarie',
        SOGLabel: 'Anläggningstillgång/Inventarie',
        SBLabel: 'Anläggningstillgången/Inventarien',
        SBGLabel: 'Anläggningstillgången/Inventarien',
        POLabel: 'Anläggningstillgångar/Inventarier',
        POGLabel: 'Anläggningstillgångar/Inventarier',
        PBLabel: 'Anläggningstillgångarna/Inventarierna',
        PBGLabel: 'Anläggningstillgångarna/Inventarierna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Anläggningstillgången/Inventarien primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Anläggningstillgången/Inventarien versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Anläggningstillgången/Inventarien id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Anläggningstillgången/Inventarien fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANLAGGNINGS_NR: {
          AttributeName: 'ANLAGGNINGS_NR',
          DisplayLabel: 'Anläggningsnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 14,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          Hint: 'Anläggningstillgång/Inventaries benämning.',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        ANLKATDATA1: {
          AttributeName: 'ANLKATDATA1',
          DisplayLabel: 'Övriga uppgifter 1',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Övriga uppgifter',
        },
        ANLKATDATA2: {
          AttributeName: 'ANLKATDATA2',
          DisplayLabel: 'Övriga uppgifter 2',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Övriga uppgifter',
        },
        ANLKATDATA3: {
          AttributeName: 'ANLKATDATA3',
          DisplayLabel: 'Övriga uppgifter 3',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Övriga uppgifter',
        },
        ANLKATDATA4: {
          AttributeName: 'ANLKATDATA4',
          DisplayLabel: 'Övriga uppgifter 4',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Övriga uppgifter',
        },
        ANLKATDATA5: {
          AttributeName: 'ANLKATDATA5',
          DisplayLabel: 'Övriga uppgifter 5',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Övriga uppgifter',
        },
        ANLKATDATA6: {
          AttributeName: 'ANLKATDATA6',
          DisplayLabel: 'Övriga uppgifter 6',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Övriga uppgifter',
        },
        ANLKATDATA7: {
          AttributeName: 'ANLKATDATA7',
          DisplayLabel: 'Övriga uppgifter 7',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Övriga uppgifter',
        },
        ANLKATDATA8: {
          AttributeName: 'ANLKATDATA8',
          DisplayLabel: 'Övriga uppgifter 8',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Övriga uppgifter',
        },
        RUBRIK_ID: {
          AttributeName: 'RUBRIK_ID',
          DisplayLabel: 'Rubrik',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANLKAT_ID: {
          AttributeName: 'ANLKAT_ID',
          DisplayLabel: 'Anläggningskategori',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PLATS_ID: {
          AttributeName: 'PLATS_ID',
          DisplayLabel: 'Plats',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        ANLGRUPP_ID: {
          AttributeName: 'ANLGRUPP_ID',
          DisplayLabel: 'Anl. grupp id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANLAGGNTILLG: {
          AttributeName: 'ANLAGGNTILLG',
          DisplayLabel: 'Anläggningstillgång (J/N)',
          Hint: 'Definierar om denna anläggning/inventarie är en anläggningstillgång.\0D\0AAnläggningstillgångar kommer med på bokföringsunderlaget.\0D\0AEn kostnadsförd anläggning/inventerie är ingen anläggningstillgång - Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        UtrangeringsDatum: {
          AttributeName: 'UtrangeringsDatum',
          DisplayLabel: 'Avyttring/utrangering, datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Avyttrad/Utrangerad/Omklass',
        },
        AckUppr: {
          AttributeName: 'AckUppr',
          DisplayLabel: 'Per månad, ack investeringar',
          Hint: 'Investeringar t o m angiven månad',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Per månad',
        },
        AckInv: {
          AttributeName: 'AckInv',
          DisplayLabel: 'Ack investerat',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AckAvskr: {
          AttributeName: 'AckAvskr',
          DisplayLabel: 'Per månad, ack avskrivningar',
          Hint: 'Bokförda och kalkylerade avskrivningar t o m angiven månad',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Per månad',
        },
        AckNedskr: {
          AttributeName: 'AckNedskr',
          DisplayLabel: 'Per månad, ack nedskrivningar',
          Hint: 'Nedskrivningar t o m angiven månad',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Per månad',
        },
        AckUppskr: {
          AttributeName: 'AckUppskr',
          DisplayLabel: 'Ack uppskrivet',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
        },
        StatusAvyttr: {
          AttributeName: 'StatusAvyttr',
          DisplayLabel: 'Avyttrad (J/N)',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          AttributeGroup: 'Avyttrad/Utrangerad/Omklass',
        },
        AretIngBokf: {
          AttributeName: 'AretIngBokf',
          DisplayLabel: 'Per månad, årets ingående värde',
          Hint: 'Ingående värde per angivet år, bokförda och kalkylerade händelser',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Per månad',
        },
        AretIngInv: {
          AttributeName: 'AretIngInv',
          DisplayLabel: 'Ingående investerat',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AretIngAvskr: {
          AttributeName: 'AretIngAvskr',
          DisplayLabel: 'Ingående avskrivet',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AretIngNedskr: {
          AttributeName: 'AretIngNedskr',
          DisplayLabel: 'Ingående nedskrivet',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AretIngUppskr: {
          AttributeName: 'AretIngUppskr',
          DisplayLabel: 'Ingående uppskrivet',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AretUppr: {
          AttributeName: 'AretUppr',
          DisplayLabel: 'Per månad, årets investeringar',
          Hint: 'Årets investeringar t o m angiven månad',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Per månad',
        },
        AretInv: {
          AttributeName: 'AretInv',
          DisplayLabel: 'Investerar under året',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AretAvskr: {
          AttributeName: 'AretAvskr',
          DisplayLabel: 'Per månad, årets avskrivningar',
          Hint: 'Årets avskrivningar t o m angiven månad, bokförda och kalkylerade',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Per månad',
        },
        AretNedskr: {
          AttributeName: 'AretNedskr',
          DisplayLabel: 'Per månad, årets nedskrivningar',
          Hint: 'Årets nedskrivningar t o m angiven månad',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Per månad',
        },
        AretUppskr: {
          AttributeName: 'AretUppskr',
          DisplayLabel: 'Uppskrivet under året',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AretUtgBokf: {
          AttributeName: 'AretUtgBokf',
          DisplayLabel: 'Per månad, restvärde',
          Hint: 'Årets utgående värden t o m angiven månad',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Per månad',
        },
        AretForsaljnPris: {
          AttributeName: 'AretForsaljnPris',
          DisplayLabel: 'Försäljningpris, sålt under året',
          Hint: 'Försäljningpris för inventarier som sålts under året',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AckForsaljnPris: {
          AttributeName: 'AckForsaljnPris',
          DisplayLabel: 'Avyttring, försäljningspris',
          Hint: 'Sålt t o m angiven månad',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
        },
        AckRestVarde: {
          AttributeName: 'AckRestVarde',
          DisplayLabel: 'Utgående restvärde',
          Hint: 'Utgående restvärde per angiven månad',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AckRealVinst: {
          AttributeName: 'AckRealVinst',
          DisplayLabel: 'Avyttring, realisationsvinst',
          Hint: 'Realisationsvinst t o m angiven månad',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
        },
        KBAvskrKontoDeb: {
          AttributeName: 'KBAvskrKontoDeb',
          DisplayLabel: 'KBAvskrKontoDeb',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ConstantValue', '-5;']]),
        },
        KBAvskrKontoKred: {
          AttributeName: 'KBAvskrKontoKred',
          DisplayLabel: 'KBAvskrKontoKred',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ConstantValue', '-7;']]),
        },
        KBInternRantaDeb: {
          AttributeName: 'KBInternRantaDeb',
          DisplayLabel: 'KBInternRantaDeb',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ConstantValue', '-8;']]),
        },
        KBInternRantaKred: {
          AttributeName: 'KBInternRantaKred',
          DisplayLabel: 'KBInternRantaKred',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ConstantValue', '-9;']]),
        },
        AvskrKontoDeb: {
          AttributeName: 'AvskrKontoDeb',
          DisplayLabel: 'Konteringsmall - Avskrivning debet',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Konteringsmall',
        },
        AvskrKontoKred: {
          AttributeName: 'AvskrKontoKred',
          DisplayLabel: 'Konteringsmall - Avskrivning kredit',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Konteringsmall',
        },
        InternRantaDeb: {
          AttributeName: 'InternRantaDeb',
          DisplayLabel: 'Konteringsmall - Internränta debet',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Konteringsmall',
        },
        InternRantaKred: {
          AttributeName: 'InternRantaKred',
          DisplayLabel: 'Konteringsmall - Internränta kredit',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Konteringsmall',
        },
        ANSKAFFDATUM_FROM: {
          AttributeName: 'ANSKAFFDATUM_FROM',
          DisplayLabel: 'Anskaffningsdatum, from',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDateStr',
          FormatterParseParams: 'AllowIncomplete="Y"',
        },
        ANSKAFFDATUM_TOM: {
          AttributeName: 'ANSKAFFDATUM_TOM',
          DisplayLabel: 'Anskaffningsdatum, tom',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDateStr',
          FormatterParseParams: 'AllowIncomplete="Y"',
        },
        AnskaffDatum: {
          AttributeName: 'AnskaffDatum',
          DisplayLabel: 'Anskaffningsdatum',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        Integrerad: {
          AttributeName: 'Integrerad',
          DisplayLabel: 'Integrerad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        AckumuleradeInvesteringar: {
          AttributeName: 'AckumuleradeInvesteringar',
          DisplayLabel: 'Anskaffningsvärde, investeringar',
          Hint: 'Bokförda och registrerade investeringar',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Belopp',
        },
        AckumuleradeAvskrivningar: {
          AttributeName: 'AckumuleradeAvskrivningar',
          DisplayLabel: 'Bokfört värde, avskrivningar',
          Hint: 'Bokförda och registrerade avskrivningar',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Belopp',
        },
        AckumuleradeNedskr: {
          AttributeName: 'AckumuleradeNedskr',
          DisplayLabel: 'Bokfört värde, nedskrivningar',
          Hint: 'Bokförda och registrerade nedskrivningar',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Belopp',
        },
        BokfortRestbelopp: {
          AttributeName: 'BokfortRestbelopp',
          DisplayLabel: 'Bokfört restvärde',
          Hint: 'Bokförda och registrerade investeringar, avskrivningar och nedskrivningar',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Belopp',
        },
        Avyttrad: {
          AttributeName: 'Avyttrad',
          DisplayLabel: 'Avyttrad/Utrangerad (J/N)',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Avyttrad/Utrangerad/Omklass',
        },
        Omklassificerad: {
          AttributeName: 'Omklassificerad',
          DisplayLabel: 'Omklassificerad (J/N)',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Avyttrad/Utrangerad/Omklass',
        },
        harLikaInvBen: {
          AttributeName: 'harLikaInvBen',
          DisplayLabel: 'harLikaInvBen',
          Hint: 'om tillgången har 2 eller fler investeringar med samma benämning - Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        VERKSAMHETSKOD_ID: {
          AttributeName: 'VERKSAMHETSKOD_ID',
          DisplayLabel: 'Verksamhetskod, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RubrikSomInvKonto: {
          AttributeName: 'RubrikSomInvKonto',
          DisplayLabel: 'RubrikSomInvKonto',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AvyttrDat: {
          AttributeName: 'AvyttrDat',
          DisplayLabel: 'Avyttring/utrangering, datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Avyttrad/Utrangerad/Omklass',
        },
        BokfAvyttrUtr: {
          AttributeName: 'BokfAvyttrUtr',
          DisplayLabel: 'Bokförd avyttring/utrangering',
          Hint: 'Är anläggningstillgången avyttrad, utrangerad eller omklassificerad - Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        Bildfinns: {
          AttributeName: 'Bildfinns',
          DisplayLabel: 'Bild finns',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Bild',
        },
        KvarvarandePerDatum: {
          AttributeName: 'KvarvarandePerDatum',
          DisplayLabel: 'Kvarvarande per datum',
          DataType: 'Date',
          Attribute: 'None',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.notless, T.less],
          DefaultCondOperator: T.notless,
        },
        BILDANTECKNING: {
          AttributeName: 'BILDANTECKNING',
          DisplayLabel: 'Bild anteckning',
          DataType: 'String',
          Attribute: 'None',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.interval, T.notinterval],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bild',
        },
        BILDDATUM: {
          AttributeName: 'BILDDATUM',
          DisplayLabel: 'Bild fildatum',
          DataType: 'Date',
          Attribute: 'None',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.interval, T.notinterval],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Bild',
        },
        RuleID: {
          AttributeName: 'RuleID',
          DisplayLabel: 'RuleID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        InvSerieId: {
          AttributeName: 'InvSerieId',
          DisplayLabel: 'InvSerieId',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SenasteAvskr: {
          AttributeName: 'SenasteAvskr',
          DisplayLabel: 'Datum för senaste avskriving',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
        },
        INTERNRANTEBERAKNAS: {
          AttributeName: 'INTERNRANTEBERAKNAS',
          DisplayLabel: 'Internränteberäknas',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        HarAvyttring: {
          AttributeName: 'HarAvyttring',
          DisplayLabel: 'Har avyttring',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Avyttrad/Utrangerad/Omklass',
        },
        HarUtrangering: {
          AttributeName: 'HarUtrangering',
          DisplayLabel: 'Har utrangering',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Avyttrad/Utrangerad/Omklass',
        },
        HarOmklassificering: {
          AttributeName: 'HarOmklassificering',
          DisplayLabel: 'Har omklassificering',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Avyttrad/Utrangerad/Omklass',
        },
        HarAvyttringSenasteDatum: {
          AttributeName: 'HarAvyttringSenasteDatum',
          DisplayLabel: 'HarAvyttringSenasteDatum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        HarUtrangeringSenasteDatum: {
          AttributeName: 'HarUtrangeringSenasteDatum',
          DisplayLabel: 'HarUtrangeringSenasteDatum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        HarOmklassificeringSenasteDatum: {
          AttributeName: 'HarOmklassificeringSenasteDatum',
          DisplayLabel: 'HarOmklassificeringSenasteDatum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        FORVALTNINGSFASTIGHET: {
          AttributeName: 'FORVALTNINGSFASTIGHET',
          DisplayLabel: 'Förvaltningsfastighet',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Förvaltningsfastighet',
        },
        SenasteVarderingVarde: {
          AttributeName: 'SenasteVarderingVarde',
          DisplayLabel: 'Senaste värdering',
          Hint: 'Beloppet för senaste värderingen',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNone',
          AttributeGroup: 'Förvaltningsfastighet',
        },
        SenasteVarderingVardedatum: {
          AttributeName: 'SenasteVarderingVardedatum',
          DisplayLabel: 'Senaste värderingsdatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNone',
          AttributeGroup: 'Förvaltningsfastighet',
        },
        HarAvskrivningSenasteDatum: {
          AttributeName: 'HarAvskrivningSenasteDatum',
          DisplayLabel: 'HarAvskrivningSenasteDatum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        EndastAvyttrad: {
          AttributeName: 'EndastAvyttrad',
          DisplayLabel: 'Avyttrad (J/N)',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Avyttrad/Utrangerad/Omklass',
        },
        EndastUtrangerad: {
          AttributeName: 'EndastUtrangerad',
          DisplayLabel: 'Utrangerad (J/N)',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Avyttrad/Utrangerad/Omklass',
        },
        AterstManader: {
          AttributeName: 'AterstManader',
          DisplayLabel: 'Återst avskr tid',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AnlnrBen: {
          AttributeName: 'AnlnrBen',
          DisplayLabel: 'Anl.nr och benämning',
          Hint: 'På formatet 9999 - XXXXXXXX',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        HISTORISKT_ID: {
          AttributeName: 'HISTORISKT_ID',
          DisplayLabel: 'Anläggningsnr i tidigare system',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Övrigt',
        },
        RuleKplanID: {
          AttributeName: 'RuleKplanID',
          DisplayLabel: 'RuleKplanID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
        },
        AvskrKontoDeb2: {
          AttributeName: 'AvskrKontoDeb2',
          DisplayLabel: 'AvskrKontoDeb2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        InternRantaDeb2: {
          AttributeName: 'InternRantaDeb2',
          DisplayLabel: 'InternRantaDeb2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        HarRubrikByt: {
          AttributeName: 'HarRubrikByt',
          DisplayLabel: 'Har bytt rubrik',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        HarUpprForeAr: {
          AttributeName: 'HarUpprForeAr',
          DisplayLabel: 'HarUpprForeAr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeParams: {'UpprStartAr': {type: 'String', defaultValue: ''}},
        },
        ANLKATDATA1_ANDRAD_SIGN: {
          AttributeName: 'ANLKATDATA1_ANDRAD_SIGN',
          DisplayLabel: 'Ändrad signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ANLKATDATA2_ANDRAD_SIGN: {
          AttributeName: 'ANLKATDATA2_ANDRAD_SIGN',
          DisplayLabel: 'Ändrad signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ANLKATDATA3_ANDRAD_SIGN: {
          AttributeName: 'ANLKATDATA3_ANDRAD_SIGN',
          DisplayLabel: 'Ändrad signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ANLKATDATA4_ANDRAD_SIGN: {
          AttributeName: 'ANLKATDATA4_ANDRAD_SIGN',
          DisplayLabel: 'Ändrad signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ANLKATDATA5_ANDRAD_SIGN: {
          AttributeName: 'ANLKATDATA5_ANDRAD_SIGN',
          DisplayLabel: 'Ändrad signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ANLKATDATA6_ANDRAD_SIGN: {
          AttributeName: 'ANLKATDATA6_ANDRAD_SIGN',
          DisplayLabel: 'Ändrad signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ANLKATDATA7_ANDRAD_SIGN: {
          AttributeName: 'ANLKATDATA7_ANDRAD_SIGN',
          DisplayLabel: 'Ändrad signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ANLKATDATA8_ANDRAD_SIGN: {
          AttributeName: 'ANLKATDATA8_ANDRAD_SIGN',
          DisplayLabel: 'Ändrad signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ANLKATDATA1_ANDRAD_DATUM: {
          AttributeName: 'ANLKATDATA1_ANDRAD_DATUM',
          DisplayLabel: 'Ändrad datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ANLKATDATA2_ANDRAD_DATUM: {
          AttributeName: 'ANLKATDATA2_ANDRAD_DATUM',
          DisplayLabel: 'Ändrad datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ANLKATDATA3_ANDRAD_DATUM: {
          AttributeName: 'ANLKATDATA3_ANDRAD_DATUM',
          DisplayLabel: 'Ändrad datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ANLKATDATA4_ANDRAD_DATUM: {
          AttributeName: 'ANLKATDATA4_ANDRAD_DATUM',
          DisplayLabel: 'Ändrad datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ANLKATDATA5_ANDRAD_DATUM: {
          AttributeName: 'ANLKATDATA5_ANDRAD_DATUM',
          DisplayLabel: 'Ändrad datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ANLKATDATA6_ANDRAD_DATUM: {
          AttributeName: 'ANLKATDATA6_ANDRAD_DATUM',
          DisplayLabel: 'Ändrad datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ANLKATDATA7_ANDRAD_DATUM: {
          AttributeName: 'ANLKATDATA7_ANDRAD_DATUM',
          DisplayLabel: 'Ändrad datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ANLKATDATA8_ANDRAD_DATUM: {
          AttributeName: 'ANLKATDATA8_ANDRAD_DATUM',
          DisplayLabel: 'Ändrad datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ANLKATDATA1_ANDRAD_FRAN: {
          AttributeName: 'ANLKATDATA1_ANDRAD_FRAN',
          DisplayLabel: 'Ändrad i',
          Hint: 'Anläggningsregistret/Webinventeringen',
          DataType: 'Enum',
          EnumValues: new Map([['ANLAGGNINGSREGISTRET', 'Anläggningsregistret'], ['WEBINVENTERINGEN', 'Webinventeringen']]),
          EnumSortValues: new Map([['ANLAGGNINGSREGISTRET', 'A'], ['WEBINVENTERINGEN', 'W']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANLAGGNINGSREGISTRET=Anläggningsregistret;WEBINVENTERINGEN=Webinventeringen"',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ANLKATDATA2_ANDRAD_FRAN: {
          AttributeName: 'ANLKATDATA2_ANDRAD_FRAN',
          DisplayLabel: 'Ändrad i',
          Hint: 'Anläggningsregistret/Webinventeringen',
          DataType: 'Enum',
          EnumValues: new Map([['ANLAGGNINGSREGISTRET', 'Anläggningsregistret'], ['WEBINVENTERINGEN', 'Webinventeringen']]),
          EnumSortValues: new Map([['ANLAGGNINGSREGISTRET', 'A'], ['WEBINVENTERINGEN', 'W']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANLAGGNINGSREGISTRET=Anläggningsregistret;WEBINVENTERINGEN=Webinventeringen"',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ANLKATDATA3_ANDRAD_FRAN: {
          AttributeName: 'ANLKATDATA3_ANDRAD_FRAN',
          DisplayLabel: 'Ändrad i',
          Hint: 'Anläggningsregistret/Webinventeringen',
          DataType: 'Enum',
          EnumValues: new Map([['ANLAGGNINGSREGISTRET', 'Anläggningsregistret'], ['WEBINVENTERINGEN', 'Webinventeringen']]),
          EnumSortValues: new Map([['ANLAGGNINGSREGISTRET', 'A'], ['WEBINVENTERINGEN', 'W']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANLAGGNINGSREGISTRET=Anläggningsregistret;WEBINVENTERINGEN=Webinventeringen"',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ANLKATDATA4_ANDRAD_FRAN: {
          AttributeName: 'ANLKATDATA4_ANDRAD_FRAN',
          DisplayLabel: 'Ändrad i',
          Hint: 'Anläggningsregistret/Webinventeringen',
          DataType: 'Enum',
          EnumValues: new Map([['ANLAGGNINGSREGISTRET', 'Anläggningsregistret'], ['WEBINVENTERINGEN', 'Webinventeringen']]),
          EnumSortValues: new Map([['ANLAGGNINGSREGISTRET', 'A'], ['WEBINVENTERINGEN', 'W']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANLAGGNINGSREGISTRET=Anläggningsregistret;WEBINVENTERINGEN=Webinventeringen"',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ANLKATDATA5_ANDRAD_FRAN: {
          AttributeName: 'ANLKATDATA5_ANDRAD_FRAN',
          DisplayLabel: 'Ändrad i',
          Hint: 'Anläggningsregistret/Webinventeringen',
          DataType: 'Enum',
          EnumValues: new Map([['ANLAGGNINGSREGISTRET', 'Anläggningsregistret'], ['WEBINVENTERINGEN', 'Webinventeringen']]),
          EnumSortValues: new Map([['ANLAGGNINGSREGISTRET', 'A'], ['WEBINVENTERINGEN', 'W']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANLAGGNINGSREGISTRET=Anläggningsregistret;WEBINVENTERINGEN=Webinventeringen"',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ANLKATDATA6_ANDRAD_FRAN: {
          AttributeName: 'ANLKATDATA6_ANDRAD_FRAN',
          DisplayLabel: 'Ändrad i',
          Hint: 'Anläggningsregistret/Webinventeringen',
          DataType: 'Enum',
          EnumValues: new Map([['ANLAGGNINGSREGISTRET', 'Anläggningsregistret'], ['WEBINVENTERINGEN', 'Webinventeringen']]),
          EnumSortValues: new Map([['ANLAGGNINGSREGISTRET', 'A'], ['WEBINVENTERINGEN', 'W']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANLAGGNINGSREGISTRET=Anläggningsregistret;WEBINVENTERINGEN=Webinventeringen"',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ANLKATDATA7_ANDRAD_FRAN: {
          AttributeName: 'ANLKATDATA7_ANDRAD_FRAN',
          DisplayLabel: 'Ändrad i',
          Hint: 'Anläggningsregistret/Webinventeringen',
          DataType: 'Enum',
          EnumValues: new Map([['ANLAGGNINGSREGISTRET', 'Anläggningsregistret'], ['WEBINVENTERINGEN', 'Webinventeringen']]),
          EnumSortValues: new Map([['ANLAGGNINGSREGISTRET', 'A'], ['WEBINVENTERINGEN', 'W']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANLAGGNINGSREGISTRET=Anläggningsregistret;WEBINVENTERINGEN=Webinventeringen"',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ANLKATDATA8_ANDRAD_FRAN: {
          AttributeName: 'ANLKATDATA8_ANDRAD_FRAN',
          DisplayLabel: 'Ändrad i',
          Hint: 'Anläggningsregistret/Webinventeringen',
          DataType: 'Enum',
          EnumValues: new Map([['ANLAGGNINGSREGISTRET', 'Anläggningsregistret'], ['WEBINVENTERINGEN', 'Webinventeringen']]),
          EnumSortValues: new Map([['ANLAGGNINGSREGISTRET', 'A'], ['WEBINVENTERINGEN', 'W']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANLAGGNINGSREGISTRET=Anläggningsregistret;WEBINVENTERINGEN=Webinventeringen"',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SenastAndradAnlKatData1: {
          AttributeName: 'SenastAndradAnlKatData1',
          DisplayLabel: 'Senast ändrad anl.kat 1',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        SenastAndradAnlKatData2: {
          AttributeName: 'SenastAndradAnlKatData2',
          DisplayLabel: 'Senast ändrad anl.kat 2',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        SenastAndradAnlKatData3: {
          AttributeName: 'SenastAndradAnlKatData3',
          DisplayLabel: 'Senast ändrad anl.kat 3',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        SenastAndradAnlKatData4: {
          AttributeName: 'SenastAndradAnlKatData4',
          DisplayLabel: 'Senast ändrad anl.kat 4',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        SenastAndradAnlKatData5: {
          AttributeName: 'SenastAndradAnlKatData5',
          DisplayLabel: 'Senast ändrad anl.kat 5',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        SenastAndradAnlKatData6: {
          AttributeName: 'SenastAndradAnlKatData6',
          DisplayLabel: 'Senast ändrad anl.kat 6',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        SenastAndradAnlKatData7: {
          AttributeName: 'SenastAndradAnlKatData7',
          DisplayLabel: 'Senast ändrad anl.kat 7',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        SenastAndradAnlKatData8: {
          AttributeName: 'SenastAndradAnlKatData8',
          DisplayLabel: 'Senast ändrad anl.kat 8',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        FI_KVARVARANDE: {
          AttributeName: 'FI_KVARVARANDE',
          DisplayLabel: 'Förbrukn. inv, kvarvarande',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        ForbruknKvarvarande: {
          AttributeName: 'ForbruknKvarvarande',
          DisplayLabel: 'Förbrukn.inv, kvarvarande',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Förbrukningsinventarie',
        },
        KanHaSkattemassigaVarden: {
          AttributeName: 'KanHaSkattemassigaVarden',
          DisplayLabel: 'Kan ha skattemässiga värden',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Skattemässiga värden',
        },
        HarSkattemassigaVarden: {
          AttributeName: 'HarSkattemassigaVarden',
          DisplayLabel: 'Har skattemässiga värden',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Skattemässiga värden',
        },
        SKVAvyttradUtrang: {
          AttributeName: 'SKVAvyttradUtrang',
          DisplayLabel: 'Skattemässigt avyttrad/utrangerad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Skattemässiga värden',
        },
        SKVRestvarde: {
          AttributeName: 'SKVRestvarde',
          DisplayLabel: 'SKVRestvarde',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        SKVSenasteAvskr: {
          AttributeName: 'SKVSenasteAvskr',
          DisplayLabel: 'SKVSenasteAvskr',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        SKVSenasteNedskr: {
          AttributeName: 'SKVSenasteNedskr',
          DisplayLabel: 'SKVSenasteNedskr',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        SKVSenasteAvrakningDatum: {
          AttributeName: 'SKVSenasteAvrakningDatum',
          DisplayLabel: 'Senaste skattemässiga händelse',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Blob: {
          AssociationName: 'Blob',
          DisplayLabel: 'Blob',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARTillgangBlob',
          AssociatedComponentName: 'TillgangBlob',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: true,
          Properties: new Map([]),
        },
        Plats: {
          AssociationName: 'Plats',
          DisplayLabel: 'Byggnad, område och rum',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARPlats',
          AssociatedComponentName: 'Plats',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        AnlKat: {
          AssociationName: 'AnlKat',
          DisplayLabel: 'Anläggningskategori',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARAnlKat',
          AssociatedComponentName: 'AnlKat',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Rubrik: {
          AssociationName: 'Rubrik',
          DisplayLabel: 'Rubrik',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARRubrik',
          AssociatedComponentName: 'Rubrik',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        AvskrkontoDeb: {
          AssociationName: 'AvskrkontoDeb',
          DisplayLabel: 'Avskrivningskonto debet',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        AvskrkontoKred: {
          AssociationName: 'AvskrkontoKred',
          DisplayLabel: 'Avskrivningskonto kredit',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        InternrantekontoDeb: {
          AssociationName: 'InternrantekontoDeb',
          DisplayLabel: 'Internränta debet',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        InternrantekontoKred: {
          AssociationName: 'InternrantekontoKred',
          DisplayLabel: 'Internränta kredit',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        AnlGrupp: {
          AssociationName: 'AnlGrupp',
          DisplayLabel: 'Anläggningsgrupp',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARAnlGrupp',
          AssociatedComponentName: 'AnlGrupp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Verksamhetskod: {
          AssociationName: 'Verksamhetskod',
          DisplayLabel: 'Verksamhetskod',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARVerksamhetskod',
          AssociatedComponentName: 'Verksamhetskod',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Upprakningar: {
          AssociationName: 'Upprakningar',
          DisplayLabel: 'Investeringar',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARUpprakning',
          AssociatedComponentName: 'Upprakning',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Dokument: {
          AssociationName: 'Dokument',
          DisplayLabel: 'Dokument',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARTillgangOLE',
          AssociatedComponentName: 'TillgangOLE',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Atgard: {
          AssociationName: 'Atgard',
          DisplayLabel: 'Åtgärder',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARAtgard',
          AssociatedComponentName: 'Atgard',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Logg: {
          AssociationName: 'Logg',
          DisplayLabel: 'Logg',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARTillgangLogg',
          AssociatedComponentName: 'TillgangLogg',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Vardering: {
          AssociationName: 'Vardering',
          DisplayLabel: 'Värdering',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARTillgangVardering',
          AssociatedComponentName: 'TillgangVardering',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Fordelning: {
          AssociationName: 'Fordelning',
          DisplayLabel: 'Fördelningsinfo',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARTillgangFordelning',
          AssociatedComponentName: 'TillgangFordelning',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    ARTillgangBlob: {
      CollectionName: 'ARTillgangBlob',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'TillgangBlob',
        Abstract: false,
        SOLabel: '',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: '',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'ARTillgangBlobs primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'ARTillgangBlobs versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'ARTillgangBlobs id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'ARTillgangBlobs fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BESKRIVNING: {
          AttributeName: 'BESKRIVNING',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BILD: {
          AttributeName: 'BILD',
          DisplayLabel: 'Bild',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LJUD: {
          AttributeName: 'LJUD',
          DisplayLabel: 'Ljud',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BildSize: {
          AttributeName: 'BildSize',
          DisplayLabel: 'Bildstorlek',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LjudSize: {
          AttributeName: 'LjudSize',
          DisplayLabel: 'Ljudstorlek',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BILDANTECKNING: {
          AttributeName: 'BILDANTECKNING',
          DisplayLabel: 'Bild anteckning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BILDDATUM: {
          AttributeName: 'BILDDATUM',
          DisplayLabel: 'Bild fildatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BESKR_ANDRAD_DATUM: {
          AttributeName: 'BESKR_ANDRAD_DATUM',
          DisplayLabel: 'Ändrad datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BESKR_ANDRAD_SIGN: {
          AttributeName: 'BESKR_ANDRAD_SIGN',
          DisplayLabel: 'Ändrad signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BESKR_ANDRAD_FRAN: {
          AttributeName: 'BESKR_ANDRAD_FRAN',
          DisplayLabel: 'Ändrad i',
          Hint: 'Anläggningsregistret/Webinventeringen',
          DataType: 'Enum',
          EnumValues: new Map([['ANLAGGNINGSREGISTRET', 'Anläggningsregistret'], ['WEBINVENTERINGEN', 'Webinventeringen']]),
          EnumSortValues: new Map([['ANLAGGNINGSREGISTRET', 'A'], ['WEBINVENTERINGEN', 'W']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANLAGGNINGSREGISTRET=Anläggningsregistret;WEBINVENTERINGEN=Webinventeringen"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        SenastAndradText: {
          AttributeName: 'SenastAndradText',
          DisplayLabel: 'Senast ändrad',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    ARUpprBlob: {
      CollectionName: 'ARUpprBlob',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'UpprBlob',
        Abstract: false,
        SOLabel: 'Bild',
        SOGLabel: 'Bilds',
        SBLabel: 'Bilden',
        SBGLabel: 'Bildens',
        POLabel: 'Bilder',
        POGLabel: 'Bilders',
        PBLabel: 'Bilderna',
        PBGLabel: 'Bildernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Bildens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Bildens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Bildens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BILD: {
          AttributeName: 'BILD',
          DisplayLabel: 'Bild',
          DataType: 'ID',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        BILDSIZE: {
          AttributeName: 'BILDSIZE',
          DisplayLabel: 'Bild',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BILDSTRETCH: {
          AttributeName: 'BILDSTRETCH',
          DisplayLabel: 'Bild',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BILDANTECKNING: {
          AttributeName: 'BILDANTECKNING',
          DisplayLabel: 'Bildanteckning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        BILDDATUM: {
          AttributeName: 'BILDDATUM',
          DisplayLabel: 'Bilddatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BILD_ANDRAD: {
          AttributeName: 'BILD_ANDRAD',
          DisplayLabel: 'Bild ändrad datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BILD_ANDRAD_SIGN: {
          AttributeName: 'BILD_ANDRAD_SIGN',
          DisplayLabel: 'Bild ändrad av',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BILD_WEBAVENY: {
          AttributeName: 'BILD_WEBAVENY',
          DisplayLabel: 'Bild ändrad i WebAveny',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    ARTillgangOLE: {
      CollectionName: 'ARTillgangOLE',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'Y']]),
      RootType: {
        TypeValue: 'TillgangOLE',
        Abstract: false,
        SOLabel: 'Dokument',
        SOGLabel: 'Dokument',
        SBLabel: 'Dokumentet',
        SBGLabel: 'Dokumentet',
        POLabel: 'Dokument',
        POGLabel: 'Dokument',
        PBLabel: 'Dokumenten',
        PBGLabel: 'Dokumenten',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Dokumentet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Dokumentet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Dokumentet id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Dokumentet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LOPNR: {
          AttributeName: 'LOPNR',
          DisplayLabel: 'Löpnr',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        BESKRIVNING: {
          AttributeName: 'BESKRIVNING',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        EXTENSION: {
          AttributeName: 'EXTENSION',
          DisplayLabel: 'Filtillägg',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 5,
        },
        OLECLASSNAME: {
          AttributeName: 'OLECLASSNAME',
          DisplayLabel: 'OLE klassnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 40,
        },
        BINARDATA: {
          AttributeName: 'BINARDATA',
          DisplayLabel: 'Dokument',
          DataType: 'ID',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        BinarDataSize: {
          AttributeName: 'BinarDataSize',
          DisplayLabel: 'BlobStorlek',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ApplicationIdentifier: {
          AttributeName: 'ApplicationIdentifier',
          DisplayLabel: 'Applikation',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        FileIdentifier: {
          AttributeName: 'FileIdentifier',
          DisplayLabel: 'Filidentifikation',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        DATATYPE: {
          AttributeName: 'DATATYPE',
          DisplayLabel: 'Datatyp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AVSER_BOKFAR: {
          AttributeName: 'AVSER_BOKFAR',
          DisplayLabel: 'Avser bokföringsår',
          Hint: 'Dokumenten tas med vid eventuell export till arkivsystem. Exporten sker per bokföringsår.  Om "avser bokföringsår" är satt så tas dokumentet med för endast detta bokföringsår. Om "avser år" är tomt så tas dokumentet med varje år.',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateYear',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Tillgang: {
          AssociationName: 'Tillgang',
          DisplayLabel: 'Anläggningstillgång',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'ARTillgang',
          AssociatedComponentName: 'Tillgang',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    ARHuvudRubrikAnlGrupp: {
      CollectionName: 'ARHuvudRubrikAnlGrupp',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'HuvudRubrikAnlGrupp',
        Abstract: false,
        SOLabel: 'Huvudrubrik anl. grupp',
        SOGLabel: 'Huvudrubrik anl. grupp',
        SBLabel: 'Huvudrubrik anl. gruppen',
        SBGLabel: 'Huvudrubrik anl. gruppen',
        POLabel: 'Huvudrubrik anl. grupper',
        POGLabel: 'Huvudrubrik anl. grupper',
        PBLabel: 'Huvudrubrik anl. grupperna',
        PBGLabel: 'Huvudrubrik anl. grupperna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Huvudrubrik anl. gruppen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Huvudrubrik anl. gruppen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Huvudrubrik anl. gruppen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Huvudrubrik anl. gruppen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        HUVUDRUBRIK_ID: {
          AttributeName: 'HUVUDRUBRIK_ID',
          DisplayLabel: 'HuvudRubrikId',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        INV_SERIE_ID: {
          AttributeName: 'INV_SERIE_ID',
          DisplayLabel: 'Inventarieserie',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        xHuvudRubrik: {
          AttributeName: 'xHuvudRubrik',
          DisplayLabel: 'Huvudrubrik',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        xNummerserie: {
          AttributeName: 'xNummerserie',
          DisplayLabel: 'Nummerserie',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Huvudrubrik: {
          AssociationName: 'Huvudrubrik',
          DisplayLabel: 'Huvudrubrik',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARHuvudRubrik',
          AssociatedComponentName: 'HuvudRubrik',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Nummerserie: {
          AssociationName: 'Nummerserie',
          DisplayLabel: 'Nummerserie',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSNummerserie',
          AssociatedComponentName: 'NummerSerie',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    ARHuvudRubrik: {
      CollectionName: 'ARHuvudRubrik',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'HuvudRubrik',
        Abstract: false,
        SOLabel: 'Huvudrubrik',
        SOGLabel: 'Huvudrubrik',
        SBLabel: 'Huvudrubriken',
        SBGLabel: 'Huvudrubriken',
        POLabel: 'Huvudrubriker',
        POGLabel: 'Huvudrubriker',
        PBLabel: 'Huvudrubrikerna',
        PBGLabel: 'Huvudrubrikerna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Huvudrubriken primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Huvudrubriken versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Huvudrubriken id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Huvudrubriken fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ConditionShowValues', 'True;']]),
        },
        ANLAGGNTILLG: {
          AttributeName: 'ANLAGGNTILLG',
          DisplayLabel: 'Anläggningstillgång (J/N)',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        ATGARDER: {
          AttributeName: 'ATGARDER',
          DisplayLabel: 'Registrering av åtgärder',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        IDKOD: {
          AttributeName: 'IDKOD',
          DisplayLabel: 'ID-kod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 20,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        HuvudRubrikAnlGrupp: {
          AssociationName: 'HuvudRubrikAnlGrupp',
          DisplayLabel: 'HuvudRubrikAnlGrupp',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'ARHuvudRubrikAnlGrupp',
          AssociatedComponentName: 'HuvudRubrikAnlGrupp',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        HuvudRubrikRubrik: {
          AssociationName: 'HuvudRubrikRubrik',
          DisplayLabel: 'HuvudRubrikRubrik',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'ARRubrik',
          AssociatedComponentName: 'Rubrik',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    ARIgnoreradeUppr: {
      CollectionName: 'ARIgnoreradeUppr',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'IgnoreradeUppr',
        Abstract: false,
        SOLabel: 'Ignorerade investering',
        SOGLabel: 'Ignorerade investerings',
        SBLabel: 'Ignorerade investeringen',
        SBGLabel: 'Ignorerade investeringens',
        POLabel: 'Ignorerade investeringar',
        POGLabel: 'Ignorerade investeringars',
        PBLabel: 'Ignorerade investeringarna',
        PBGLabel: 'Ignorerade investeringarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Ignorerade investeringens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Ignorerade investeringens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Ignorerade investeringens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        OMGANG_ID: {
          AttributeName: 'OMGANG_ID',
          DisplayLabel: 'Id, inventeringsomgång',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        UPPR_TILLGANG_ID: {
          AttributeName: 'UPPR_TILLGANG_ID',
          DisplayLabel: 'Id, tillgång',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        UPPR_LOPNR: {
          AttributeName: 'UPPR_LOPNR',
          DisplayLabel: 'Löpnr, investering',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BORTTAGEN_SIGN: {
          AttributeName: 'BORTTAGEN_SIGN',
          DisplayLabel: 'Borttagen av',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 250,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Upprakning: {
          AssociationName: 'Upprakning',
          DisplayLabel: 'Investeringar',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARUpprakning',
          AssociatedComponentName: 'Upprakning',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    ARInventering: {
      CollectionName: 'ARInventering',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Inventering',
        Abstract: false,
        SOLabel: 'Inventering',
        SOGLabel: 'Inventerings',
        SBLabel: 'Inventeringen',
        SBGLabel: 'Inventeringens',
        POLabel: 'Inventeringar',
        POGLabel: 'Inventeringars',
        PBLabel: 'Inventeringarna',
        PBGLabel: 'Inventeringarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Inventeringens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Inventeringens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Inventeringens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        StatusDatum: {
          AttributeName: 'StatusDatum',
          DisplayLabel: 'Status',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        USER_ID: {
          AttributeName: 'USER_ID',
          DisplayLabel: 'Id, användare',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FORESLAGEN_ATGARD: {
          AttributeName: 'FORESLAGEN_ATGARD',
          DisplayLabel: 'Föreslagen åtgärd',
          Hint: 'Ingen åtgärd/Ska utrangeras/Fungerar ej för avsett ändamål/Justering av avskr.tid',
          DataType: 'Enum',
          EnumValues: new Map([['INGEN_ATGARD', 'Ingen åtgärd'], ['SKA_UTRANGERAS', 'Ska utrangeras'], ['FUNGERAR_EJ_FOR_AVSETT_ANDAMAL', 'Fungerar ej för avsett ändamål'], ['JUSTERING_AV_AVSKR_TID', 'Justering av avskr.tid']]),
          EnumSortValues: new Map([['INGEN_ATGARD', 'I'], ['SKA_UTRANGERAS', 'U'], ['FUNGERAR_EJ_FOR_AVSETT_ANDAMAL', 'S'], ['JUSTERING_AV_AVSKR_TID', 'J']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="INGEN_ATGARD=Ingen åtgärd;SKA_UTRANGERAS=Ska utrangeras;FUNGERAR_EJ_FOR_AVSETT_ANDAMAL=Fungerar ej för avsett ändamål;JUSTERING_AV_AVSKR_TID=Justering av avskr.tid"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ATGARD_KOMMENTAR: {
          AttributeName: 'ATGARD_KOMMENTAR',
          DisplayLabel: 'Övriga kommentarer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        STATUS_INVENTERING: {
          AttributeName: 'STATUS_INVENTERING',
          DisplayLabel: 'Status',
          Hint: 'Påbörjad/Klarmarkerad',
          DataType: 'Enum',
          EnumValues: new Map([['PABORJAD', 'Påbörjad'], ['KLARMARKERAD', 'Klarmarkerad']]),
          EnumSortValues: new Map([['PABORJAD', 'P'], ['KLARMARKERAD', 'K']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="PABORJAD=Påbörjad;KLARMARKERAD=Klarmarkerad"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        STATUS_DATUM: {
          AttributeName: 'STATUS_DATUM',
          DisplayLabel: 'Status datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        FINNS_KVAR: {
          AttributeName: 'FINNS_KVAR',
          DisplayLabel: 'Finns kvar',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SKA_NEDSKR: {
          AttributeName: 'SKA_NEDSKR',
          DisplayLabel: 'Skall skrivas ned',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SKA_JUSTERA_AVSKRTID: {
          AttributeName: 'SKA_JUSTERA_AVSKRTID',
          DisplayLabel: 'Ska justera avskrivningstid',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        NEDSKRBELOPP_FORSLAG: {
          AttributeName: 'NEDSKRBELOPP_FORSLAG',
          DisplayLabel: 'Föreslaget nedskrivningsbelopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        AVSKRTID_FORSLAG: {
          AttributeName: 'AVSKRTID_FORSLAG',
          DisplayLabel: 'Ny föreslagen avskrivningstid',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KLARMARKERAD: {
          AttributeName: 'KLARMARKERAD',
          DisplayLabel: 'Klarmarkerad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        OmgangNamn: {
          AttributeName: 'OmgangNamn',
          DisplayLabel: 'Omgång och namn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        xUtrangering: {
          AttributeName: 'xUtrangering',
          DisplayLabel: 'xUtrangering',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNone',
        },
        xNedskrivning: {
          AttributeName: 'xNedskrivning',
          DisplayLabel: 'xNedskrivning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNone',
        },
        xAvskrTid: {
          AttributeName: 'xAvskrTid',
          DisplayLabel: 'xJustering avskrivningstid',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNone',
        },
        STATUS_ATGARD: {
          AttributeName: 'STATUS_ATGARD',
          DisplayLabel: 'Status, åtgärd',
          Hint: 'Ej åtgärdad/Godkänd utan åtgärd/Godkänd med åtgärd/Redan avyttrad/utrangerad',
          DataType: 'Enum',
          EnumValues: new Map([['EJ_ATGARDAD', 'Ej åtgärdad'], ['GODKAND_UTAN_ATGARD', 'Godkänd utan åtgärd'], ['GODKAND_MED_ATGARD', 'Godkänd med åtgärd'], ['REDAN_AVYTTRAD_UTRANGERAD', 'Redan avyttrad/utrangerad']]),
          EnumSortValues: new Map([['EJ_ATGARDAD', 'E'], ['GODKAND_UTAN_ATGARD', 'U'], ['GODKAND_MED_ATGARD', 'M'], ['REDAN_AVYTTRAD_UTRANGERAD', 'R']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="EJ_ATGARDAD=Ej åtgärdad;GODKAND_UTAN_ATGARD=Godkänd utan åtgärd;GODKAND_MED_ATGARD=Godkänd med åtgärd;REDAN_AVYTTRAD_UTRANGERAD=Redan avyttrad/utrangerad"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KommentarForslagTid: {
          AttributeName: 'KommentarForslagTid',
          DisplayLabel: 'Kommentar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        ANDRAD_PLAC_TEXT: {
          AttributeName: 'ANDRAD_PLAC_TEXT',
          DisplayLabel: 'Ändrad placering',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 255,
        },
        ATGARD_SIGN: {
          AttributeName: 'ATGARD_SIGN',
          DisplayLabel: 'Signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KOMMENTAR_ANLREG: {
          AttributeName: 'KOMMENTAR_ANLREG',
          DisplayLabel: 'Kommentar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        AndradPlacText: {
          AttributeName: 'AndradPlacText',
          DisplayLabel: 'Ändrar placering',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        AVSKRTID_FORSLAG_AR: {
          AttributeName: 'AVSKRTID_FORSLAG_AR',
          DisplayLabel: 'sad',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KombineradStatus: {
          AttributeName: 'KombineradStatus',
          DisplayLabel: 'Status',
          Hint: 'Påbörjad/Klarmarkerad/Godkänd inventering/Redan avyttrad/utrangerad',
          DataType: 'Enum',
          EnumValues: new Map([['PABORJAD', 'Påbörjad'], ['KLARMARKERAD', 'Klarmarkerad'], ['GODKAND_INVENTERING', 'Godkänd inventering'], ['REDAN_AVYTTRAD_UTRANGERAD', 'Redan avyttrad/utrangerad']]),
          EnumSortValues: new Map([['PABORJAD', 'P'], ['KLARMARKERAD', 'K'], ['GODKAND_INVENTERING', 'G'], ['REDAN_AVYTTRAD_UTRANGERAD', 'R']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="PABORJAD=Påbörjad;KLARMARKERAD=Klarmarkerad;GODKAND_INVENTERING=Godkänd inventering;REDAN_AVYTTRAD_UTRANGERAD=Redan avyttrad/utrangerad"',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Inventeringsomgang: {
          AssociationName: 'Inventeringsomgang',
          DisplayLabel: 'Inventeringsomgång',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARInvOmgang',
          AssociatedComponentName: 'InvOmgang',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Anvandare: {
          AssociationName: 'Anvandare',
          DisplayLabel: 'Användare',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Upprakning: {
          AssociationName: 'Upprakning',
          DisplayLabel: 'Uppräkning',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARUpprakning',
          AssociatedComponentName: 'Upprakning',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    ARInvAnsvariga: {
      CollectionName: 'ARInvAnsvariga',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'InvAnsvariga',
        Abstract: false,
        SOLabel: 'Inventeringsansvariga',
        SOGLabel: 'Inventeringsansvariga',
        SBLabel: 'Inventeringsansvariga',
        SBGLabel: 'Inventeringsansvariga',
        POLabel: 'Inventeringsansvariga',
        POGLabel: 'Inventeringsansvariga',
        PBLabel: 'Inventeringsansvariga',
        PBGLabel: 'Inventeringsansvariga',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Inventeringsansvariga primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Inventeringsansvariga versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Inventeringsansvariga fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VIEW_ID: {
          AttributeName: 'VIEW_ID',
          DisplayLabel: 'Id, urval',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Urval: {
          AssociationName: 'Urval',
          DisplayLabel: 'Urval',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUrval',
          AssociatedComponentName: 'Urval',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Anvandare: {
          AssociationName: 'Anvandare',
          DisplayLabel: 'Användare',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        InvOmgAnsvariga: {
          AssociationName: 'InvOmgAnsvariga',
          DisplayLabel: 'InvOmgAnsvariga',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARInvOmgAnsvariga',
          AssociatedComponentName: 'InvOmgAnsvariga',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    ARInvOmgAnsvariga: {
      CollectionName: 'ARInvOmgAnsvariga',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'InvOmgAnsvariga',
        Abstract: false,
        SOLabel: 'Inventeringsomgångansvariga',
        SOGLabel: 'Inventeringsomgångansvarigas',
        SBLabel: 'Inventeringsomgångansvariga',
        SBGLabel: 'Inventeringsomgångansvarigas',
        POLabel: 'Inventeringsomgångansvariga',
        POGLabel: 'Inventeringsomgångansvarigas',
        PBLabel: 'Inventeringsomgångansvariga',
        PBGLabel: 'Inventeringsomgångansvarigas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Inventeringsomgångansvarigas primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Inventeringsomgångansvarigas versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Inventeringsomgångansvarigas fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Ansvarig: {
          AssociationName: 'Ansvarig',
          DisplayLabel: 'Ansvarig',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARInvAnsvariga',
          AssociatedComponentName: 'InvAnsvariga',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    ARInvOmgang: {
      CollectionName: 'ARInvOmgang',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'InvOmgang',
        Abstract: false,
        SOLabel: 'Inventeringsomgång',
        SOGLabel: 'Inventeringsomgångs',
        SBLabel: 'Inventeringsomgången',
        SBGLabel: 'Inventeringsomgångens',
        POLabel: 'Inventeringsomgångar',
        POGLabel: 'Inventeringsomgångars',
        PBLabel: 'Inventeringsomgångarna',
        PBGLabel: 'Inventeringsomgångarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Inventeringsomgångens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Inventeringsomgångens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Inventeringsomgångens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NR: {
          AttributeName: 'NR',
          DisplayLabel: 'Nr',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TOM_PERIOD: {
          AttributeName: 'TOM_PERIOD',
          DisplayLabel: 'T.o.m period',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        SKAPAD_DATUM: {
          AttributeName: 'SKAPAD_DATUM',
          DisplayLabel: 'Skapad datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Klarmarkerad/Skapad/Distribuerad',
          DataType: 'Enum',
          EnumValues: new Map([['KLARMARKERAD', 'Klarmarkerad'], ['SKAPAD', 'Skapad'], ['DISTRIBUERAD', 'Distribuerad']]),
          EnumSortValues: new Map([['KLARMARKERAD', 'K'], ['SKAPAD', 'S'], ['DISTRIBUERAD', 'D']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="KLARMARKERAD=Klarmarkerad;SKAPAD=Skapad;DISTRIBUERAD=Distribuerad"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        DistribueradText: {
          AttributeName: 'DistribueradText',
          DisplayLabel: 'Distribuerad',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DISTRIBUERAD_DATUM: {
          AttributeName: 'DISTRIBUERAD_DATUM',
          DisplayLabel: 'Distribuerad datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        MEDDELANDE: {
          AttributeName: 'MEDDELANDE',
          DisplayLabel: 'Meddelande',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Inventeringar: {
          AssociationName: 'Inventeringar',
          DisplayLabel: 'Inventeringar',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARInventering',
          AssociatedComponentName: 'Inventering',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Ansvariga: {
          AssociationName: 'Ansvariga',
          DisplayLabel: 'Ansvariga',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARInvOmgAnsvariga',
          AssociatedComponentName: 'InvOmgAnsvariga',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        IgnoreradeInvesteringar: {
          AssociationName: 'IgnoreradeInvesteringar',
          DisplayLabel: 'Ignorerade investeringar',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARIgnoreradeUppr',
          AssociatedComponentName: 'IgnoreradeUppr',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    ARUpprakning: {
      CollectionName: 'ARUpprakning',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '3012']]),
      RootType: {
        TypeValue: 'Upprakning',
        Abstract: true,
        SOLabel: 'Investering',
        SOGLabel: 'Investering',
        SBLabel: 'Investeringen',
        SBGLabel: 'Investeringen',
        POLabel: 'Investeringar',
        POGLabel: 'Investeringar',
        PBLabel: 'Investeringarna',
        PBGLabel: 'Investeringarna',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'Investering',
            Abstract: false,
            SOLabel: 'Normal investering',
            SOGLabel: 'Normal investering',
            SBLabel: 'Normala investeringen',
            SBGLabel: 'Normala investeringen',
            POLabel: 'Normala investeringar',
            POGLabel: 'Normala investeringar',
            PBLabel: 'Normala investeringarna',
            PBGLabel: 'Normala investeringarna',
            Visible: false,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'Uppskrivning',
            Abstract: false,
            SOLabel: 'Uppskrivning',
            SOGLabel: 'Uppskrivning',
            SBLabel: 'Uppskrivningen',
            SBGLabel: 'Uppskrivningen',
            POLabel: 'Uppskrivningar',
            POGLabel: 'Uppskrivningar',
            PBLabel: 'Uppskrivningarna',
            PBGLabel: 'Uppskrivningarna',
            Visible: false,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'OmklassUppr',
            Abstract: false,
            SOLabel: 'Omklass.uppräkning',
            SOGLabel: 'Omklass.uppräkning',
            SBLabel: 'Omklass.uppräkningen',
            SBGLabel: 'Omklass.uppräkningen',
            POLabel: 'Omklass.uppräkningar',
            POGLabel: 'Omklass.uppräkningar',
            PBLabel: 'Omklass.uppräkningarna',
            PBGLabel: 'Omklass.uppräkningarna',
            Visible: false,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'IngInvestering',
            Abstract: false,
            SOLabel: 'Ingående investering',
            SOGLabel: 'Ingående investering',
            SBLabel: 'Ingående investeringen',
            SBGLabel: 'Ingående investeringen',
            POLabel: 'Ingående investeringar',
            POGLabel: 'Ingående investeringar',
            PBLabel: 'Ingående investeringarna',
            PBGLabel: 'Ingående investeringarna',
            Visible: true,
            ChildTypes: [
              {
                TypeValue: 'DeladInvestering',
                Abstract: false,
                SOLabel: 'Investering från avskiljning',
                SOGLabel: 'Investering från avskiljning',
                SBLabel: 'Investeringen från avskiljning',
                SBGLabel: 'Investeringen från avskiljning',
                POLabel: 'Investeringar från avskiljning',
                POGLabel: 'Investeringar från avskiljning',
                PBLabel: 'Investeringarna från avskiljning',
                PBGLabel: 'Investeringarna från avskiljning',
                Visible: true,
                ChildTypes: [
                ],
              },
              {
                TypeValue: 'SammanslagenInvestering',
                Abstract: false,
                SOLabel: 'Sammanslagen investering',
                SOGLabel: 'Sammanslagen investerings',
                SBLabel: 'Sammanslagna investeringen',
                SBGLabel: 'Sammanslagna investeringens',
                POLabel: 'Sammanslagna investeringar',
                POGLabel: 'Sammanslagna investeringars',
                PBLabel: 'Sammanslagna investeringarna',
                PBGLabel: 'Sammanslagna investeringarnas',
                Visible: true,
                ChildTypes: [
                ],
              },
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Investeringen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Investeringen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Uppräkningstyp',
          DataType: 'Enum',
          EnumValues: new Map([['INVESTERING', 'Normal investering'], ['UPPSKRIVNING', 'Uppskrivning'], ['OMKLASSUPPR', 'Omklass.uppräkning'], ['INGINVESTERING', 'Ingående investering'], ['DELADINVESTERING', 'Investering från avskiljning'], ['SAMMANSLAGENINVESTERING', 'Sammanslagen investering']]),
          EnumSortValues: new Map([['INVESTERING', 'I'], ['UPPSKRIVNING', 'U'], ['OMKLASSUPPR', 'O'], ['INGINVESTERING', 'N'], ['DELADINVESTERING', 'D'], ['SAMMANSLAGENINVESTERING', 'S']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifTypeTree',
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Investeringen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Investeringen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Text',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 100,
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Datum',
          Hint: 'Datum för investeringen',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        AVSKRMAN: {
          AttributeName: 'AVSKRMAN',
          DisplayLabel: 'Avskr tid (år)',
          Hint: 'Askrivningstiden sparas i antal månader men visas i år',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BELOPP: {
          AttributeName: 'BELOPP',
          DisplayLabel: 'Belopp',
          Hint: 'Investeringsbelopp',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        BESKRIVNING: {
          AttributeName: 'BESKRIVNING',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 250,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        VERNR: {
          AttributeName: 'VERNR',
          DisplayLabel: 'Verifikationsnummer',
          Hint: 'Registrerat verifikationsnr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Övrigt',
        },
        AVSKRIVNTYP: {
          AttributeName: 'AVSKRIVNTYP',
          DisplayLabel: 'Avskrivningstyp',
          Hint: 'Anger hur investeringen/uppskrivningen skall skrivas av\0D\0AFöljande möjligheter finns\0D\0A- Normal avskrivning\0D\0A- Avskrivs ej\0D\0A- Kostnadsförd - Normal avskrivning/Avskrivs ej/Kostnadsförd',
          DataType: 'Enum',
          EnumValues: new Map([['NORMAL_AVSKRIVNING', 'Normal avskrivning'], ['AVSKRIVS_EJ', 'Avskrivs ej'], ['KOSTNADSFORD', 'Kostnadsförd']]),
          EnumSortValues: new Map([['NORMAL_AVSKRIVNING', 'N'], ['AVSKRIVS_EJ', 'O'], ['KOSTNADSFORD', 'K']]),
          Attribute: 'Internal',
          Condition: 'Internal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NORMAL_AVSKRIVNING=Normal avskrivning;AVSKRIVS_EJ=Avskrivs ej;KOSTNADSFORD=Kostnadsförd"',
          InterfaceType: 'ifChecklist',
        },
        AckUppr: {
          AttributeName: 'AckUppr',
          DisplayLabel: 'Ack uppräknat',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AckAvskr: {
          AttributeName: 'AckAvskr',
          DisplayLabel: 'Ackumulerade avskrivningar',
          Hint: 'Ackumulerade avskrivningar t o m angiven månad',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AckNedskr: {
          AttributeName: 'AckNedskr',
          DisplayLabel: 'Ack. nedskrivet',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AretIngBokf: {
          AttributeName: 'AretIngBokf',
          DisplayLabel: 'Ingående bokfört',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AretUppr: {
          AttributeName: 'AretUppr',
          DisplayLabel: 'Uppräknat under året',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AretAvskr: {
          AttributeName: 'AretAvskr',
          DisplayLabel: 'Avskrivet under året',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AretNedskr: {
          AttributeName: 'AretNedskr',
          DisplayLabel: 'Nedskrivet under året',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AretUtgBokf: {
          AttributeName: 'AretUtgBokf',
          DisplayLabel: 'Utgående bokfört',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ForsaljnPris: {
          AttributeName: 'ForsaljnPris',
          DisplayLabel: 'Försäljningspris',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RestVarde: {
          AttributeName: 'RestVarde',
          DisplayLabel: 'Restvärde',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RealVinst: {
          AttributeName: 'RealVinst',
          DisplayLabel: 'Realisationsvinst',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RestManader: {
          AttributeName: 'RestManader',
          DisplayLabel: 'Återstår månader',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KBInkopskonto: {
          AttributeName: 'KBInkopskonto',
          DisplayLabel: 'KBInkopskonto',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ConstantValue', '-10;']]),
        },
        Inkopskonto: {
          AttributeName: 'Inkopskonto',
          DisplayLabel: 'Bokföringskonto',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        AvskrTom: {
          AttributeName: 'AvskrTom',
          DisplayLabel: 'Avskriven t o m datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        InvBelopp: {
          AttributeName: 'InvBelopp',
          DisplayLabel: 'Belopp',
          Hint: 'Investeringsbelopp',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        InvBeloppAck: {
          AttributeName: 'InvBeloppAck',
          DisplayLabel: 'Investeringsbelopp',
          Hint: 'Investeringsbelopp inkl avskiljning',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        InvBeloppPerDatum: {
          AttributeName: 'InvBeloppPerDatum',
          DisplayLabel: 'Investeringsbelopp per datum',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeParams: {'rvp_datum': {type: 'Date', defaultValue: ''}},
        },
        InternrantaPerBokfar: {
          AttributeName: 'InternrantaPerBokfar',
          DisplayLabel: 'Internränta per bokf.år',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeParams: {'INTRANTA_BOKF_AR': {type: 'Date', defaultValue: ''}},
        },
        SenasteAvskr: {
          AttributeName: 'SenasteAvskr',
          DisplayLabel: 'SenasteAvskr',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        SenasteNedskr: {
          AttributeName: 'SenasteNedskr',
          DisplayLabel: 'Senaste nedskrivning',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        PrevDatum: {
          AttributeName: 'PrevDatum',
          DisplayLabel: 'PrevDatum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BokfortRestbelopp: {
          AttributeName: 'BokfortRestbelopp',
          DisplayLabel: 'Bokfört restvärde',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        RestVardePerDatum: {
          AttributeName: 'RestVardePerDatum',
          DisplayLabel: 'Per månad, bokfört restvärde',
          Hint: 'Utgående restvärde per angivet datum',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeGroup: 'Per månad',
          AttributeParams: {'rvp_datum': {type: 'Date', defaultValue: ''}},
        },
        IngVardePerDatum: {
          AttributeName: 'IngVardePerDatum',
          DisplayLabel: 'Per månad, bokfört årets ing värde',
          Hint: 'Årets ingående restvärde per angivet datum',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeGroup: 'Per månad',
          AttributeParams: {'rvp_datum': {type: 'Date', defaultValue: ''}},
        },
        AretInvPerDatum: {
          AttributeName: 'AretInvPerDatum',
          DisplayLabel: 'Per månad, bokförda årets investeringar',
          Hint: 'Årets investeringar tom angivet datum',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeGroup: 'Per månad',
          AttributeParams: {'rvp_datum': {type: 'Date', defaultValue: ''}},
        },
        AretAvskrPerDatum: {
          AttributeName: 'AretAvskrPerDatum',
          DisplayLabel: 'Per månad, bokförda årets avskrivningar',
          Hint: 'Årets avskrivningar tom angivet datum',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeGroup: 'Per månad',
          AttributeParams: {'rvp_datum': {type: 'Date', defaultValue: ''}},
        },
        AretNedskrPerDatum: {
          AttributeName: 'AretNedskrPerDatum',
          DisplayLabel: 'Per månad, bokförda årets nedskrivningar',
          Hint: 'Årets nedskrivningar tom angivet datum',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeGroup: 'Per månad',
          AttributeParams: {'rvp_datum': {type: 'Date', defaultValue: ''}},
        },
        AretForsaljnPerDatum: {
          AttributeName: 'AretForsaljnPerDatum',
          DisplayLabel: 'Per månad, försäljningspris, sålt under året',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeGroup: 'Per månad',
          AttributeParams: {'rvp_datum': {type: 'Date', defaultValue: ''}},
        },
        AretAterfInvPerDatum: {
          AttributeName: 'AretAterfInvPerDatum',
          DisplayLabel: 'Per månad, årets återföring av investeringar',
          Hint: 'Årets återföring av investeringar t o m angivet datum',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeGroup: 'Per månad',
          AttributeParams: {'rvp_datum': {type: 'Date', defaultValue: ''}},
        },
        AretAterfAvskrPerDatum: {
          AttributeName: 'AretAterfAvskrPerDatum',
          DisplayLabel: 'Per månad, årets återföring av avskrivningar',
          Hint: 'Årets återföring av avskrivningar t o m angivet datum',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeGroup: 'Per månad',
          AttributeParams: {'rvp_datum': {type: 'Date', defaultValue: ''}},
        },
        AretAterfNedskrPerDatum: {
          AttributeName: 'AretAterfNedskrPerDatum',
          DisplayLabel: 'Per månad, årets återföring av nedskrivningar',
          Hint: 'Årets återföring av nedskrivningar t o m angivet datum',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeGroup: 'Per månad',
          AttributeParams: {'rvp_datum': {type: 'Date', defaultValue: ''}},
        },
        AretOmklassPerDatum: {
          AttributeName: 'AretOmklassPerDatum',
          DisplayLabel: 'Per månad, omklassificering under året',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Per månad',
          AttributeParams: {'rvp_datum': {type: 'Date', defaultValue: ''}},
        },
        Utrangerad: {
          AttributeName: 'Utrangerad',
          DisplayLabel: 'Utrangerad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          AttributeGroup: 'Övrigt',
        },
        IngAvskrPerDatum: {
          AttributeName: 'IngAvskrPerDatum',
          DisplayLabel: 'Per månad, bokförda årets ingående avskrivningar',
          Hint: 'Året, ingående avskrivningar per angivet år',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeGroup: 'Per månad',
          AttributeParams: {'rvp_datum': {type: 'Date', defaultValue: ''}},
        },
        IngNedskrPerDatum: {
          AttributeName: 'IngNedskrPerDatum',
          DisplayLabel: 'Per månad, bokförda årets ingående nedskrivningar',
          Hint: 'Året, ingående nedskrivningar per angivet år',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeGroup: 'Per månad',
          AttributeParams: {'rvp_datum': {type: 'Date', defaultValue: ''}},
        },
        FAKTURA: {
          AttributeName: 'FAKTURA',
          DisplayLabel: 'Fakturanr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 128,
        },
        LEV: {
          AttributeName: 'LEV',
          DisplayLabel: 'Leverantör',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 128,
        },
        AvyttradPerDatum: {
          AttributeName: 'AvyttradPerDatum',
          DisplayLabel: 'Per månad, avyttrad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          AttributeGroup: 'Per månad',
          AttributeParams: {'rvp_datum': {type: 'Date', defaultValue: ''}},
        },
        JustInvBelopp: {
          AttributeName: 'JustInvBelopp',
          DisplayLabel: 'JustInvBelopp',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
        },
        JustAvskrBelopp: {
          AttributeName: 'JustAvskrBelopp',
          DisplayLabel: 'JustAvskrBelopp',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
        },
        JustRestBelopp: {
          AttributeName: 'JustRestBelopp',
          DisplayLabel: 'JustRestBelopp',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANTECKNING: {
          AttributeName: 'ANTECKNING',
          DisplayLabel: 'Anteckning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 200,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        VERKSAMHETSKOD_ID: {
          AttributeName: 'VERKSAMHETSKOD_ID',
          DisplayLabel: 'Verksamhetskod, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        IngAnskPerDatum: {
          AttributeName: 'IngAnskPerDatum',
          DisplayLabel: 'Per månad, ingående anskaffningsvärde',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Per månad',
          AttributeParams: {'rvp_datum': {type: 'Date', defaultValue: ''}},
        },
        DeladTomDatum: {
          AttributeName: 'DeladTomDatum',
          DisplayLabel: 'DeladTomDatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          AttributeGroup: 'Övrigt',
        },
        OmklassPerDatum: {
          AttributeName: 'OmklassPerDatum',
          DisplayLabel: 'Per månad, omklassificerad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          AttributeGroup: 'Per månad',
          AttributeParams: {'rvp_datum': {type: 'Date', defaultValue: ''}},
        },
        Omklassificerad: {
          AttributeName: 'Omklassificerad',
          DisplayLabel: 'Omklassificerad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        Inkopskonto_del1: {
          AttributeName: 'Inkopskonto_del1',
          DisplayLabel: '@KONTO1@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Bokföringskonto',
        },
        Inkopskonto_del2: {
          AttributeName: 'Inkopskonto_del2',
          DisplayLabel: '@KONTO2@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Bokföringskonto',
        },
        Inkopskonto_del3: {
          AttributeName: 'Inkopskonto_del3',
          DisplayLabel: '@KONTO3@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Bokföringskonto',
        },
        Inkopskonto_del4: {
          AttributeName: 'Inkopskonto_del4',
          DisplayLabel: '@KONTO4@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Bokföringskonto',
        },
        Inkopskonto_del5: {
          AttributeName: 'Inkopskonto_del5',
          DisplayLabel: '@KONTO5@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Bokföringskonto',
        },
        Inkopskonto_del6: {
          AttributeName: 'Inkopskonto_del6',
          DisplayLabel: '@KONTO6@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Bokföringskonto',
        },
        Inkopskonto_del7: {
          AttributeName: 'Inkopskonto_del7',
          DisplayLabel: '@KONTO7@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Bokföringskonto',
        },
        Inkopskonto_del8: {
          AttributeName: 'Inkopskonto_del8',
          DisplayLabel: '@KONTO8@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Bokföringskonto',
        },
        Inkopskonto_del9: {
          AttributeName: 'Inkopskonto_del9',
          DisplayLabel: '@KONTO9@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Bokföringskonto',
        },
        Inkopskonto_del10: {
          AttributeName: 'Inkopskonto_del10',
          DisplayLabel: '@KONTO10@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Bokföringskonto',
        },
        Avyttrad: {
          AttributeName: 'Avyttrad',
          DisplayLabel: 'Avyttrad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          AttributeGroup: 'Övrigt',
        },
        InternrantaPerDatum: {
          AttributeName: 'InternrantaPerDatum',
          DisplayLabel: 'Internränta per datum',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeParams: {'INTRANTA_DATUM': {type: 'Date', defaultValue: ''}},
        },
        BokfAvyttrUtrang: {
          AttributeName: 'BokfAvyttrUtrang',
          DisplayLabel: 'BokfAvyttrUtrang',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        RuleTILLGANG_ID: {
          AttributeName: 'RuleTILLGANG_ID',
          DisplayLabel: 'RuleTILLGANG_ID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RuleUPPR_LOPNR: {
          AttributeName: 'RuleUPPR_LOPNR',
          DisplayLabel: 'RuleUPPR_LOPNR',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BokfBelopp: {
          AttributeName: 'BokfBelopp',
          DisplayLabel: 'BokförtBelopp',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          ValidInComps: ['Investering'],
        },
        RegBelopp: {
          AttributeName: 'RegBelopp',
          DisplayLabel: 'Registrerat belopp',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          ValidInComps: ['Investering'],
        },
        ING_RESTVARDE: {
          AttributeName: 'ING_RESTVARDE',
          DisplayLabel: 'Registrerat ingående restvärde',
          Hint: 'Restvärde för en investering av typen Ingående investering',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['IngInvestering'],
          AttributeGroup: 'Ingående investering',
        },
        ING_DATUM: {
          AttributeName: 'ING_DATUM',
          DisplayLabel: 'Registrerat ing investeringsdatum',
          Hint: 'Registrerat ing investeringsdatum för en investering av typen Ingående investering',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['IngInvestering'],
          AttributeGroup: 'Ingående investering',
        },
        ING_AVSKRMAN: {
          AttributeName: 'ING_AVSKRMAN',
          DisplayLabel: 'Registrerad återstående avskr.tid',
          Hint: 'Registrerad återstående avskr.tid för en investering av typen Ingående investering',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['IngInvestering'],
          AttributeGroup: 'Ingående investering',
        },
        ING_AVSKRDATUM: {
          AttributeName: 'ING_AVSKRDATUM',
          DisplayLabel: 'Ingående avskrivningsmånad',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          ValidInComps: ['IngInvestering'],
        },
        REF_DELNING_TILLGANG_ID: {
          AttributeName: 'REF_DELNING_TILLGANG_ID',
          DisplayLabel: 'Tillgång id , delning',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['DeladInvestering'],
        },
        REF_DELNING_UPPR_LOPNR: {
          AttributeName: 'REF_DELNING_UPPR_LOPNR',
          DisplayLabel: 'Uppr löpnr, delning',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['DeladInvestering'],
        },
        REF_DELNING_LOPNR: {
          AttributeName: 'REF_DELNING_LOPNR',
          DisplayLabel: 'Löpnr, delning',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['DeladInvestering'],
        },
        STATLIGT_STOD: {
          AttributeName: 'STATLIGT_STOD',
          DisplayLabel: 'Bidrag inv året',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Övrigt',
        },
        ING_STATLIGT_STOD: {
          AttributeName: 'ING_STATLIGT_STOD',
          DisplayLabel: 'Bidrag tidigare år',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Övrigt',
        },
        IngStatlStodPerDatum: {
          AttributeName: 'IngStatlStodPerDatum',
          DisplayLabel: 'Per månad, bokfört årets ing bidrag',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeGroup: 'Per månad',
          AttributeParams: {'rvp_datum': {type: 'String', defaultValue: ''}},
        },
        StatlStodPerDatum: {
          AttributeName: 'StatlStodPerDatum',
          DisplayLabel: 'Per månad, bidrag inv året',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeGroup: 'Per månad',
          AttributeParams: {'rvp_datum': {type: 'String', defaultValue: ''}},
        },
        AvyttrUtrangTyp: {
          AttributeName: 'AvyttrUtrangTyp',
          DisplayLabel: 'AvyttrUtrangTyp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AvyttrUtrangDatum: {
          AttributeName: 'AvyttrUtrangDatum',
          DisplayLabel: 'Avyttrad/utrangerad datum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KOMPONENT_ID: {
          AttributeName: 'KOMPONENT_ID',
          DisplayLabel: 'Komponent, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PLANERAS_ATT_SALJAS: {
          AttributeName: 'PLANERAS_ATT_SALJAS',
          DisplayLabel: 'Planeras att säljas',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PLANERAT_RESTVARDE: {
          AttributeName: 'PLANERAT_RESTVARDE',
          DisplayLabel: 'Planerat restvärde',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PlaneratForsaljnDatum: {
          AttributeName: 'PlaneratForsaljnDatum',
          DisplayLabel: 'Planerat försäljningsdatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        SkrivsAvTom: {
          AttributeName: 'SkrivsAvTom',
          DisplayLabel: 'Skrivs av tom',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        UtgAnskExklK3PerDatum: {
          AttributeName: 'UtgAnskExklK3PerDatum',
          DisplayLabel: 'Utg ansk före K3',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeParams: {'rvp_datum': {type: 'String', defaultValue: ''}},
        },
        UtgAvskrExklK3PerDatum: {
          AttributeName: 'UtgAvskrExklK3PerDatum',
          DisplayLabel: 'Utg avskr före K3',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeParams: {'rvp_datum': {type: 'String', defaultValue: ''}},
        },
        UtgNedskrExklK3PerDatum: {
          AttributeName: 'UtgNedskrExklK3PerDatum',
          DisplayLabel: 'Utg nedsk före K3',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeParams: {'rvp_datum': {type: 'String', defaultValue: ''}},
        },
        UtgVardeExklK3PerDatum: {
          AttributeName: 'UtgVardeExklK3PerDatum',
          DisplayLabel: 'Utg restv före K3',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeParams: {'rvp_datum': {type: 'String', defaultValue: ''}},
        },
        AretInvK3PerDatum: {
          AttributeName: 'AretInvK3PerDatum',
          DisplayLabel: 'Årets ansk K3',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeParams: {'rvp_datum': {type: 'String', defaultValue: ''}},
        },
        AretAvskrK3PerDatum: {
          AttributeName: 'AretAvskrK3PerDatum',
          DisplayLabel: 'Årets avskr K3',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeParams: {'rvp_datum': {type: 'String', defaultValue: ''}},
        },
        AretAterfInvK3PerDatum: {
          AttributeName: 'AretAterfInvK3PerDatum',
          DisplayLabel: 'Året återf inv K3',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeParams: {'rvp_datum': {type: 'String', defaultValue: ''}},
        },
        AretAterfAvskrK3PerDatum: {
          AttributeName: 'AretAterfAvskrK3PerDatum',
          DisplayLabel: 'Året återf avskr K3',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeParams: {'rvp_datum': {type: 'String', defaultValue: ''}},
        },
        AretAterfNedskrK3PerDatum: {
          AttributeName: 'AretAterfNedskrK3PerDatum',
          DisplayLabel: 'Året återf nedskr K3',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeParams: {'rvp_datum': {type: 'String', defaultValue: ''}},
        },
        UtrangeradK3PerDatum: {
          AttributeName: 'UtrangeradK3PerDatum',
          DisplayLabel: 'Utrangerad K3',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          AttributeParams: {'rvp_datum': {type: 'String', defaultValue: ''}},
        },
        UtrangK3Datum: {
          AttributeName: 'UtrangK3Datum',
          DisplayLabel: 'Utrangerad K3 datum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          AttributeParams: {'rvp_datum': {type: 'String', defaultValue: ''}},
        },
        HarK3Handelser: {
          AttributeName: 'HarK3Handelser',
          DisplayLabel: 'Har K3-händelser',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        IsAvyttradForeAr: {
          AttributeName: 'IsAvyttradForeAr',
          DisplayLabel: 'Är avyttrad/omklass före år',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          AttributeParams: {'rvp_datum': {type: 'String', defaultValue: ''}},
        },
        AretOmklBidragPerDatum: {
          AttributeName: 'AretOmklBidragPerDatum',
          DisplayLabel: 'Per månad, årets omklassificerade bidrag',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeGroup: 'Per månad',
          AttributeParams: {'rvp_datum': {type: 'String', defaultValue: ''}},
        },
        AretAvyttrBidragPerDatum: {
          AttributeName: 'AretAvyttrBidragPerDatum',
          DisplayLabel: 'Per månad, årets avyttrade bidrag',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeGroup: 'Per månad',
          AttributeParams: {'rvp_datum': {type: 'String', defaultValue: ''}},
        },
        AterstAvskrTidPerDatum: {
          AttributeName: 'AterstAvskrTidPerDatum',
          DisplayLabel: 'Återstående avskr tid',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Per månad',
          Properties: new Map([['NeedsAttr', 'SkrivsAvTom,AvskrTom,AVSKRIVNTYP,BokfortRestbelopp,Avyttrad,ING_DATUM,ING_AVSKRMAN']]),
        },
        EJ_INTERNRANTA: {
          AttributeName: 'EJ_INTERNRANTA',
          DisplayLabel: 'Internränteberäknas ej',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        REF_OVERFORD_TILLGANG_ID: {
          AttributeName: 'REF_OVERFORD_TILLGANG_ID',
          DisplayLabel: 'Överförd till uppräkning',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        REF_OVERFORD_UPPR_LOPNR: {
          AttributeName: 'REF_OVERFORD_UPPR_LOPNR',
          DisplayLabel: 'Överförd till uppräkning, löpnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Overford: {
          AttributeName: 'Overford',
          DisplayLabel: 'Överförd',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        OverfordDatum: {
          AttributeName: 'OverfordDatum',
          DisplayLabel: 'Överförd datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
        },
        AretOverfortPerDatum: {
          AttributeName: 'AretOverfortPerDatum',
          DisplayLabel: 'Överfört',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeParams: {'rvp_datum': {type: 'String', defaultValue: ''}},
        },
        AretOverfortAnskaffPerDatum: {
          AttributeName: 'AretOverfortAnskaffPerDatum',
          DisplayLabel: 'Överfört ansk.värde per datum',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeGroup: 'Per månad',
          AttributeParams: {'rvp_datum': {type: 'String', defaultValue: ''}},
        },
        AretOverfortIngAvskrPerDatum: {
          AttributeName: 'AretOverfortIngAvskrPerDatum',
          DisplayLabel: 'Överfört, ing avskr per datum',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeParams: {'rvp_datum': {type: 'String', defaultValue: ''}},
        },
        Avskiljd: {
          AttributeName: 'Avskiljd',
          DisplayLabel: 'Avskiljd',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        IsAvslutad: {
          AttributeName: 'IsAvslutad',
          DisplayLabel: 'Avslutad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        RestbeloppInnanAvyttr: {
          AttributeName: 'RestbeloppInnanAvyttr',
          DisplayLabel: 'RestbeloppInnanAvyttr',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        AnlBen_Lopnr: {
          AttributeName: 'AnlBen_Lopnr',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AretAvskiljtAnskaffPerDatum: {
          AttributeName: 'AretAvskiljtAnskaffPerDatum',
          DisplayLabel: 'Anskaffn värde, avskiljt per datum',
          Hint: 'Endast internt för rapporter',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeParams: {'rvp_datum': {type: 'String', defaultValue: ''}},
        },
        AretAvskiljtAvskrPerDatum: {
          AttributeName: 'AretAvskiljtAvskrPerDatum',
          DisplayLabel: 'Avskr värde, avskiljt per datum',
          Hint: 'Endast internt för rapporter',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeParams: {'rvp_datum': {type: 'String', defaultValue: ''}},
        },
        AretInvExklAvskiljPerDatum: {
          AttributeName: 'AretInvExklAvskiljPerDatum',
          DisplayLabel: 'Inköp under året exkl avskiljning',
          Hint: 'Endast för rapporter',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeParams: {'rvp_datum': {type: 'String', defaultValue: ''}},
        },
        AretAvskrExklAvskiljPerDatum: {
          AttributeName: 'AretAvskrExklAvskiljPerDatum',
          DisplayLabel: 'Årets avskrivningar exl avskiljningar',
          Hint: 'Endast för rapporter',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeParams: {'rvp_datum': {type: 'String', defaultValue: ''}},
        },
        HarFlyttats: {
          AttributeName: 'HarFlyttats',
          DisplayLabel: 'Har flyttats',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        AnlNR_Lopnr: {
          AttributeName: 'AnlNR_Lopnr',
          DisplayLabel: 'Anl nr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Startdatum: {
          AttributeName: 'Startdatum',
          DisplayLabel: 'Startdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Övrigt',
        },
        AnlBen_UpprBen: {
          AttributeName: 'AnlBen_UpprBen',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        SortInventering: {
          AttributeName: 'SortInventering',
          DisplayLabel: 'SortInventering',
          Hint: 'Påbörjad/Klarmarkerad',
          DataType: 'Enum',
          EnumValues: new Map([['PABORJAD', 'Påbörjad'], ['KLARMARKERAD', 'Klarmarkerad']]),
          EnumSortValues: new Map([['PABORJAD', 'P'], ['KLARMARKERAD', 'K']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="PABORJAD=Påbörjad;KLARMARKERAD=Klarmarkerad"',
          AttributeParams: {'inv_omg_id': {type: 'String', defaultValue: ''}},
        },
        AktuellOmgInventStatus: {
          AttributeName: 'AktuellOmgInventStatus',
          DisplayLabel: 'Status inventering',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeParams: {'inv_omg_id': {type: 'String', defaultValue: ''}},
        },
        AvskrFromDatum: {
          AttributeName: 'AvskrFromDatum',
          DisplayLabel: 'AvskrFromDatum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BESKR_ANDRAD_DATUM: {
          AttributeName: 'BESKR_ANDRAD_DATUM',
          DisplayLabel: 'Ändrad datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BESKR_ANDRAD_SIGN: {
          AttributeName: 'BESKR_ANDRAD_SIGN',
          DisplayLabel: 'Ändrad signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BESKR_ANDRAD_FRAN: {
          AttributeName: 'BESKR_ANDRAD_FRAN',
          DisplayLabel: 'Ändrad i',
          Hint: 'Anläggningsregistret/Webinventeringen',
          DataType: 'Enum',
          EnumValues: new Map([['ANLAGGNINGSREGISTRET', 'Anläggningsregistret'], ['WEBINVENTERINGEN', 'Webinventeringen']]),
          EnumSortValues: new Map([['ANLAGGNINGSREGISTRET', 'A'], ['WEBINVENTERINGEN', 'W']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANLAGGNINGSREGISTRET=Anläggningsregistret;WEBINVENTERINGEN=Webinventeringen"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        SenastAndradText: {
          AttributeName: 'SenastAndradText',
          DisplayLabel: 'Senast ändrad',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        ING_NEDSKRIVNING: {
          AttributeName: 'ING_NEDSKRIVNING',
          DisplayLabel: 'Registrerat ingående nedskrivning',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Ingående investering',
        },
        AretAktPagInvPerDatum: {
          AttributeName: 'AretAktPagInvPerDatum',
          DisplayLabel: 'Året, aktiverat från pågående investering',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeParams: {'rvp_datum': {type: 'String', defaultValue: ''}},
        },
        OVERSTYR_KLASSIFICERING: {
          AttributeName: 'OVERSTYR_KLASSIFICERING',
          DisplayLabel: 'Klassificering rapport',
          Hint: 'N/B',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterParseParams: 'TranslateValues="N=Normal;B=Ingående balans"',
          FormatterDisplayParams: 'TranslateValues="Normal=N;Ingående balans=B"',
          FormatterValidateParams: 'ValidValues="N;B;"',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        AktiveringAntalAr: {
          AttributeName: 'AktiveringAntalAr',
          DisplayLabel: 'Aktivering, antal år',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ForstaPagInvAr: {
          AttributeName: 'ForstaPagInvAr',
          DisplayLabel: 'Första påg inv år',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        harBild: {
          AttributeName: 'harBild',
          DisplayLabel: 'Har bild',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="I=Ja;T=Ja;N=Nej"',
        },
        SKV_DATUM: {
          AttributeName: 'SKV_DATUM',
          DisplayLabel: 'Urpsrungligt värderingsdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Skattemässiga värden',
        },
        SKV_AVSKRMAN: {
          AttributeName: 'SKV_AVSKRMAN',
          DisplayLabel: 'Skattemässig avskrivningstid',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Skattemässiga värden',
        },
        SKV_BELOPP: {
          AttributeName: 'SKV_BELOPP',
          DisplayLabel: 'Skattemässigt urspr värde',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Skattemässiga värden',
        },
        SKV_ING_DATUM: {
          AttributeName: 'SKV_ING_DATUM',
          DisplayLabel: 'Skattemässigt ingående datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Skattemässiga värden',
        },
        SKV_ING_AVSKRMAN: {
          AttributeName: 'SKV_ING_AVSKRMAN',
          DisplayLabel: 'Skattemässig ingående avskr tid',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Skattemässiga värden',
        },
        SKV_ING_RESTVARDE: {
          AttributeName: 'SKV_ING_RESTVARDE',
          DisplayLabel: 'Skattemässigt ingående värde',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Skattemässiga värden',
        },
        SKV_ING_NEDSKRIVNING: {
          AttributeName: 'SKV_ING_NEDSKRIVNING',
          DisplayLabel: 'Skattemässig ingående nedskrivning',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Skattemässiga värden',
        },
        SKV_NOTERING: {
          AttributeName: 'SKV_NOTERING',
          DisplayLabel: 'Skattemässig notering',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 250,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Skattemässiga värden',
        },
        SKV_SKATTEMASSIGA_VARDEN: {
          AttributeName: 'SKV_SKATTEMASSIGA_VARDEN',
          DisplayLabel: 'Hantera skattemässiga värden',
          Hint: 'Ja/Nej/Ej definierat',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej'], ['EJ_DEFINIERAT', 'Ej definierat']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N'], ['EJ_DEFINIERAT', 'E']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej;EJ_DEFINIERAT=Ej definierat"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Skattemässiga värden',
        },
        SKV_InvBelopp: {
          AttributeName: 'SKV_InvBelopp',
          DisplayLabel: 'Skattemässigt belopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          AttributeGroup: 'Skattemässiga värden',
        },
        SKVStartDatum: {
          AttributeName: 'SKVStartDatum',
          DisplayLabel: 'SKVStartDatum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          AttributeGroup: 'Skattemässiga värden',
        },
        SKVStartBelopp: {
          AttributeName: 'SKVStartBelopp',
          DisplayLabel: 'SKVStartBelopp',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Skattemässiga värden',
        },
        SKVStartAvskrman: {
          AttributeName: 'SKVStartAvskrman',
          DisplayLabel: 'SKVStartAvskrman',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Skattemässiga värden',
        },
        SKVAvskrTom: {
          AttributeName: 'SKVAvskrTom',
          DisplayLabel: 'SKVAvskrTom',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          AttributeGroup: 'Skattemässiga värden',
        },
        SKVSenasteAvskr: {
          AttributeName: 'SKVSenasteAvskr',
          DisplayLabel: 'Senaste skattemässiga avskrivning',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNone',
          AttributeGroup: 'Skattemässiga värden',
        },
        SKVSenasteNedskr: {
          AttributeName: 'SKVSenasteNedskr',
          DisplayLabel: 'Senaste skattemässiga nedskrivning',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNone',
          AttributeGroup: 'Skattemässiga värden',
        },
        SKVAvyttrUtrang: {
          AttributeName: 'SKVAvyttrUtrang',
          DisplayLabel: 'Skattemässigt avyttrad/utrangerad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Skattemässiga värden',
        },
        SKVRestvardePerDatum: {
          AttributeName: 'SKVRestvardePerDatum',
          DisplayLabel: 'Skattemässigt restvärder per datum',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          AttributeGroup: 'Skattemässiga värden',
          AttributeParams: {'rvp_datum': {type: 'Date', defaultValue: ''}},
        },
        SKVRestvarde: {
          AttributeName: 'SKVRestvarde',
          DisplayLabel: 'SKVRestvarde',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeGroup: 'Skattemässiga värden',
          AttributeParams: {'rvp_datum': {type: 'String', defaultValue: ''}},
        },
        SKVSenasteAvrakningDatum: {
          AttributeName: 'SKVSenasteAvrakningDatum',
          DisplayLabel: 'Senaste skattemässiga händelse',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          AttributeGroup: 'Skattemässiga värden',
        },
        SKVInvBeloppPerDatum: {
          AttributeName: 'SKVInvBeloppPerDatum',
          DisplayLabel: 'SKV, inv.belopp per datum',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeGroup: 'Skattemässiga värden',
          AttributeParams: {'rvp_datum': {type: 'Date', defaultValue: ''}},
        },
        SKVAvyttradPerDatum: {
          AttributeName: 'SKVAvyttradPerDatum',
          DisplayLabel: 'SKV, Avyttrad per datum',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          AttributeGroup: 'Skattemässiga värden',
          AttributeParams: {'rvp_datum': {type: 'Date', defaultValue: ''}},
        },
        SKVAretInvPerDatum: {
          AttributeName: 'SKVAretInvPerDatum',
          DisplayLabel: 'SKVAretInvPerDatum',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeGroup: 'Skattemässiga värden',
          AttributeParams: {'rvp_datum': {type: 'Date', defaultValue: ''}},
        },
        SKVAretAterfInvPerDatum: {
          AttributeName: 'SKVAretAterfInvPerDatum',
          DisplayLabel: 'SKVAretAterfInvPerDatum',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeGroup: 'Skattemässiga värden',
          AttributeParams: {'rvp_datum': {type: 'Date', defaultValue: ''}},
        },
        SKVAretAterfAvskrPerDatum: {
          AttributeName: 'SKVAretAterfAvskrPerDatum',
          DisplayLabel: 'SKVAretAterfAvskrPerDatum',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeGroup: 'Skattemässiga värden',
          AttributeParams: {'rvp_datum': {type: 'Date', defaultValue: ''}},
        },
        SKVAretAterfNedskrPerDatum: {
          AttributeName: 'SKVAretAterfNedskrPerDatum',
          DisplayLabel: 'SKVAretAterfNedskrPerDatum',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeGroup: 'Skattemässiga värden',
          AttributeParams: {'rvp_datum': {type: 'Date', defaultValue: ''}},
        },
        SKVRestbeloppInnanAvyttr: {
          AttributeName: 'SKVRestbeloppInnanAvyttr',
          DisplayLabel: 'SKVRestbeloppInnanAvyttr',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeGroup: 'Skattemässiga värden',
          AttributeParams: {'rvp_datum': {type: 'Date', defaultValue: ''}},
        },
        SKVAretAvskrPerDatum: {
          AttributeName: 'SKVAretAvskrPerDatum',
          DisplayLabel: 'SKVAretAvskrPerDatum',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeGroup: 'Skattemässiga värden',
          AttributeParams: {'rvp_datum': {type: 'Date', defaultValue: ''}},
        },
        SKVAretNedskrPerDatum: {
          AttributeName: 'SKVAretNedskrPerDatum',
          DisplayLabel: 'SKVAretNedskrPerDatum',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeGroup: 'Skattemässiga värden',
          AttributeParams: {'rvp_datum': {type: 'Date', defaultValue: ''}},
        },
        SKVAretForsaljnPerDatum: {
          AttributeName: 'SKVAretForsaljnPerDatum',
          DisplayLabel: 'SKVAretForsaljnPerDatum',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeGroup: 'Skattemässiga värden',
          AttributeParams: {'rvp_datum': {type: 'Date', defaultValue: ''}},
        },
        SKVIngAnskPerDatum: {
          AttributeName: 'SKVIngAnskPerDatum',
          DisplayLabel: 'SKVIngAnskPerDatum',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeGroup: 'Skattemässiga värden',
          AttributeParams: {'rvp_datum': {type: 'Date', defaultValue: ''}},
        },
        SKVIngAvskrPerDatum: {
          AttributeName: 'SKVIngAvskrPerDatum',
          DisplayLabel: 'SKVIngAvskrPerDatum',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeGroup: 'Skattemässiga värden',
          AttributeParams: {'rvp_datum': {type: 'Date', defaultValue: ''}},
        },
        SKVIngNedskrPerDatum: {
          AttributeName: 'SKVIngNedskrPerDatum',
          DisplayLabel: 'SKVIngNedskrPerDatum',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeGroup: 'Skattemässiga värden',
          AttributeParams: {'rvp_datum': {type: 'Date', defaultValue: ''}},
        },
        SKVAvyttrUtrangDatum: {
          AttributeName: 'SKVAvyttrUtrangDatum',
          DisplayLabel: 'SKVAvyttrUtrangDatum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          AttributeGroup: 'Skattemässiga värden',
        },
        SKV_REF_DELNING_LOPNR: {
          AttributeName: 'SKV_REF_DELNING_LOPNR',
          DisplayLabel: 'SKV Löpnr, delning',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
        },
        SKVAvskiljd: {
          AttributeName: 'SKVAvskiljd',
          DisplayLabel: 'SKV, Avskiljd',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Skattemässiga värden',
        },
        SKVUtrangerad: {
          AttributeName: 'SKVUtrangerad',
          DisplayLabel: 'Skattemässigt utrangerad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        SKVAvyttrUtrangTyp: {
          AttributeName: 'SKVAvyttrUtrangTyp',
          DisplayLabel: 'SKVAvyttrUtrangTyp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SKV_JustInvbelopp: {
          AttributeName: 'SKV_JustInvbelopp',
          DisplayLabel: 'SKV, Just Invbelopp',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        SKVAretAvskrExklAvskiljPerDatum: {
          AttributeName: 'SKVAretAvskrExklAvskiljPerDatum',
          DisplayLabel: 'Årets avskr exkl avskiljn',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeParams: {'rvp_datum': {type: 'String', defaultValue: ''}},
        },
        SKVAretInvExklAvskiljPerDatum: {
          AttributeName: 'SKVAretInvExklAvskiljPerDatum',
          DisplayLabel: 'SKVAretInvExklAvskiljPerDatum',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeParams: {'rvp_datum': {type: 'String', defaultValue: ''}},
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Tillgang: {
          AssociationName: 'Tillgang',
          DisplayLabel: 'Anläggning/inventarie',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARTillgang',
          AssociatedComponentName: 'Tillgang',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Inkopskonto: {
          AssociationName: 'Inkopskonto',
          DisplayLabel: 'Bokföringskonto',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Verksamhetskod: {
          AssociationName: 'Verksamhetskod',
          DisplayLabel: 'Verksamhetskod',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARVerksamhetskod',
          AssociatedComponentName: 'Verksamhetskod',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([]),
        },
        Komponent: {
          AssociationName: 'Komponent',
          DisplayLabel: 'Komponenttyp',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARKomponent',
          AssociatedComponentName: 'Komponent',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Blob: {
          AssociationName: 'Blob',
          DisplayLabel: 'Bild',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARUpprBlob',
          AssociatedComponentName: 'UpprBlob',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Avrakningar: {
          AssociationName: 'Avrakningar',
          DisplayLabel: 'Investeringshändelser',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARAvrakning',
          AssociatedComponentName: 'Avrakning',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        InvesteringSkatt: {
          AssociationName: 'InvesteringSkatt',
          DisplayLabel: 'Skattemässiga värden',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'ARInvesteringSkatt',
          AssociatedComponentName: 'InvesteringSkatt',
          JoinAssociation: false,
          ValidInComps: ['Investering'],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Investeringsrader: {
          AssociationName: 'Investeringsrader',
          DisplayLabel: 'Investeringsrader',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARInvesteringsrad',
          AssociatedComponentName: 'Investeringsrad',
          JoinAssociation: false,
          ValidInComps: ['Investering'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Logg: {
          AssociationName: 'Logg',
          DisplayLabel: 'Logg',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARTillgangLogg',
          AssociatedComponentName: 'TillgangLogg',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        SKVAvrakningar: {
          AssociationName: 'SKVAvrakningar',
          DisplayLabel: 'Skattemässiga investeringshändelser',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARSKVAvrakning',
          AssociatedComponentName: 'SKVAvrakning',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    ARAvrakning: {
      CollectionName: 'ARAvrakning',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Avrakning',
        Abstract: true,
        SOLabel: 'Investeringshändelse',
        SOGLabel: 'Investeringshändelse',
        SBLabel: 'Investeringshändelsen',
        SBGLabel: 'Investeringshändelsen',
        POLabel: 'Investeringshändelser',
        POGLabel: 'Investeringshändelser',
        PBLabel: 'Investeringshändelserna',
        PBGLabel: 'Investeringshändelserna',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'Avyttr',
            Abstract: true,
            SOLabel: 'Avyttring/Utrangering',
            SOGLabel: 'Avyttring/Utrangering',
            SBLabel: 'Avyttringen/Utrangeringen',
            SBGLabel: 'Avyttringen/Utrangeringen',
            POLabel: 'Avyttringar/Utrangeringar',
            POGLabel: 'Avyttringar/Utrangeringar',
            PBLabel: 'Avyttringarna/Utrangeringarna',
            PBGLabel: 'Avyttringarna/Utrangeringarna',
            Visible: true,
            ChildTypes: [
              {
                TypeValue: 'RegAvyttr',
                Abstract: false,
                SOLabel: 'Reg avyttring/utrangering',
                SOGLabel: 'Reg avyttring/utrangering',
                SBLabel: 'Reg avyttringen/utrangeringen',
                SBGLabel: 'Reg avyttringen/utrangeringen',
                POLabel: 'Reg avyttringar/utrangeringar',
                POGLabel: 'Reg avyttringar/utrangeringar',
                PBLabel: 'Reg avyttringarna/utrangeringarna',
                PBGLabel: 'Reg avyttringarna/utrangeringarna',
                Visible: true,
                ChildTypes: [
                ],
              },
              {
                TypeValue: 'BokfAvyttr',
                Abstract: false,
                SOLabel: 'Bokf avyttring/utrangering',
                SOGLabel: 'Bokf avyttring/utrangering',
                SBLabel: 'Bokf avyttringen/utrangeringen',
                SBGLabel: 'Bokf avyttringen/utrangeringen',
                POLabel: 'Bokf avyttringar/utrangeringar',
                POGLabel: 'Bokf avyttringar/utrangeringar',
                PBLabel: 'Bokf avyttringarna/utrangeringarna',
                PBGLabel: 'Bokf avyttringarna/utrangeringarna',
                Visible: true,
                ChildTypes: [
                ],
              },
            ],
          },
          {
            TypeValue: 'Nedskrivning',
            Abstract: true,
            SOLabel: 'Nedskrivning',
            SOGLabel: 'Nedskrivning',
            SBLabel: 'Nedskrivningen',
            SBGLabel: 'Nedskrivningen',
            POLabel: 'Nedskrivningar',
            POGLabel: 'Nedskrivningar',
            PBLabel: 'Nedskrivningarna',
            PBGLabel: 'Nedskrivningarna',
            Visible: true,
            ChildTypes: [
              {
                TypeValue: 'RegNedskr',
                Abstract: false,
                SOLabel: 'Registrerad nedskrivning',
                SOGLabel: 'Registrerad nedskrivning',
                SBLabel: 'Registrerade nedskrivningen',
                SBGLabel: 'Registrerade nedskrivningen',
                POLabel: 'Registrerade nedskrivningar',
                POGLabel: 'Registrerade nedskrivningar',
                PBLabel: 'Registrerade nedskrivningarna',
                PBGLabel: 'Registrerade nedskrivningarna',
                Visible: true,
                ChildTypes: [
                ],
              },
              {
                TypeValue: 'BokfNedskr',
                Abstract: false,
                SOLabel: 'Bokförd nedskrivning',
                SOGLabel: 'Bokförd nedskrivning',
                SBLabel: 'Bokförda nedskrivningen',
                SBGLabel: 'Bokförda nedskrivningen',
                POLabel: 'Bokförda nedskrivningar',
                POGLabel: 'Bokförda nedskrivningar',
                PBLabel: 'Bokförda nedskrivningarna',
                PBGLabel: 'Bokförda nedskrivningarna',
                Visible: true,
                ChildTypes: [
                ],
              },
            ],
          },
          {
            TypeValue: 'OmklassAvr',
            Abstract: false,
            SOLabel: 'Omklassificering',
            SOGLabel: 'Omklassificering',
            SBLabel: 'Omklassificeringen',
            SBGLabel: 'Omklassificeringen',
            POLabel: 'Omklassificeringar',
            POGLabel: 'Omklassificeringar',
            PBLabel: 'Omklassificeringarna',
            PBGLabel: 'Omklassificeringarna',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'Avskrivning',
            Abstract: true,
            SOLabel: 'Avskrivning',
            SOGLabel: 'Avskrivning',
            SBLabel: 'Avskrivningen',
            SBGLabel: 'Avskrivningen',
            POLabel: 'Avskrivningar',
            POGLabel: 'Avskrivningar',
            PBLabel: 'Avskrivningarna',
            PBGLabel: 'Avskrivningarna',
            Visible: true,
            ChildTypes: [
              {
                TypeValue: 'BokfAvskr',
                Abstract: false,
                SOLabel: 'Bokförd avskrivning',
                SOGLabel: 'Bokförd avskrivning',
                SBLabel: 'Bokförda avskrivningen',
                SBGLabel: 'Bokförda avskrivningen',
                POLabel: 'Bokförda avskrivningar',
                POGLabel: 'Bokförda avskrivningar',
                PBLabel: 'Bokförda avskrivningarna',
                PBGLabel: 'Bokförda avskrivningarna',
                Visible: true,
                ChildTypes: [
                ],
              },
              {
                TypeValue: 'RegAvskr',
                Abstract: false,
                SOLabel: 'Registrerad avskrivning',
                SOGLabel: 'Registrerad avskrivning',
                SBLabel: 'Registrerade avskrivningen',
                SBGLabel: 'Registrerade avskrivningen',
                POLabel: 'Registrerade avskrivningar',
                POGLabel: 'Registrerade avskrivningar',
                PBLabel: 'Registrerade avskrivningarna',
                PBGLabel: 'Registrerade avskrivningarna',
                Visible: false,
                ChildTypes: [
                ],
              },
            ],
          },
          {
            TypeValue: 'Delning',
            Abstract: false,
            SOLabel: 'Avskiljd investering',
            SOGLabel: 'Avskiljd investering',
            SBLabel: 'Avskiljda investering',
            SBGLabel: 'Avskiljda investering',
            POLabel: 'Avskiljd investeringar',
            POGLabel: 'Avskiljd investeringar',
            PBLabel: 'Avskiljd investeringarna',
            PBGLabel: 'Avskiljd investeringarna',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'Overford',
            Abstract: false,
            SOLabel: 'Överförd till ny investering',
            SOGLabel: 'Överförd till ny investering',
            SBLabel: 'Överförd till ny investering',
            SBGLabel: 'Överförd till ny investering',
            POLabel: 'Överförd till ny investering',
            POGLabel: 'Överförd till ny investering',
            PBLabel: 'Överförd till ny investering',
            PBGLabel: 'Överförd till ny investering',
            Visible: true,
            ChildTypes: [
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Investeringshändelsen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Investeringshändelsen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Avräkningstyp',
          DataType: 'Enum',
          EnumValues: new Map([['REGAVYTTR', 'Reg avyttring/utrangering'], ['BOKFAVYTTR', 'Bokf avyttring/utrangering'], ['REGNEDSKR', 'Registrerad nedskrivning'], ['BOKFNEDSKR', 'Bokförd nedskrivning'], ['OMKLASSAVR', 'Omklassificering'], ['BOKFAVSKR', 'Bokförd avskrivning'], ['REGAVSKR', 'Registrerad avskrivning'], ['DELNING', 'Avskiljd investering'], ['OVERFORD', 'Överförd till ny investering']]),
          EnumSortValues: new Map([['REGAVYTTR', 'Y'], ['BOKFAVYTTR', 'T'], ['REGNEDSKR', 'N'], ['BOKFNEDSKR', 'E'], ['OMKLASSAVR', 'O'], ['BOKFAVSKR', 'B'], ['REGAVSKR', 'R'], ['DELNING', 'D'], ['OVERFORD', 'V']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifTypeTree',
          Required: true,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Investeringshändelsen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Investeringshändelsen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        UPPR_LOPNR: {
          AttributeName: 'UPPR_LOPNR',
          DisplayLabel: 'Uppräkn löpnr',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        LOPNR: {
          AttributeName: 'LOPNR',
          DisplayLabel: 'Löpnr',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        BELOPP: {
          AttributeName: 'BELOPP',
          DisplayLabel: 'Registrerat belopp',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        RUBRIK_ID: {
          AttributeName: 'RUBRIK_ID',
          DisplayLabel: 'RUBRIK_ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BokfBelopp: {
          AttributeName: 'BokfBelopp',
          DisplayLabel: 'Bokfört belopp',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        BokfVernr: {
          AttributeName: 'BokfVernr',
          DisplayLabel: 'Verifikationsnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        BokfDatum: {
          AttributeName: 'BokfDatum',
          DisplayLabel: 'BokfDatum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        AVSKRDIFF: {
          AttributeName: 'AVSKRDIFF',
          DisplayLabel: 'Avskrivn.diff',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANTECKNING: {
          AttributeName: 'ANTECKNING',
          DisplayLabel: 'Anteckning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KUNDNUMMER: {
          AttributeName: 'KUNDNUMMER',
          DisplayLabel: 'Kundnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 128,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['Avyttr'],
          AttributeGroup: 'Avyttring',
        },
        ORDERNUMMER: {
          AttributeName: 'ORDERNUMMER',
          DisplayLabel: 'Ordernummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 128,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['Avyttr'],
          AttributeGroup: 'Avyttring',
        },
        UTRANGERAD: {
          AttributeName: 'UTRANGERAD',
          DisplayLabel: 'Utrangerad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['Avyttr'],
        },
        OmklassBelopp: {
          AttributeName: 'OmklassBelopp',
          DisplayLabel: 'OmklassBelopp',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          ValidInComps: ['OmklassAvr'],
        },
        FROM_DATUM: {
          AttributeName: 'FROM_DATUM',
          DisplayLabel: 'Fr o m datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['Avskrivning'],
          AttributeGroup: 'Avskrivning',
        },
        TOM_DATUM: {
          AttributeName: 'TOM_DATUM',
          DisplayLabel: 'T o m datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['Avskrivning'],
          AttributeGroup: 'Avskrivning',
        },
        JUST_AVSKR_BELOPP: {
          AttributeName: 'JUST_AVSKR_BELOPP',
          DisplayLabel: 'Justering avskrivningsbelopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          ValidInComps: ['Delning'],
        },
        JUST_INV_BELOPP: {
          AttributeName: 'JUST_INV_BELOPP',
          DisplayLabel: 'Justering, investeringsbelopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          ValidInComps: ['Delning'],
        },
        SortDatum: {
          AttributeName: 'SortDatum',
          DisplayLabel: 'SortDatum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AVYTTR_UTRANG_TYP: {
          AttributeName: 'AVYTTR_UTRANG_TYP',
          DisplayLabel: 'Avyttr/utrangeringstyp',
          Hint: 'Hela anläggningstillgången/Endast investeringen',
          DataType: 'Enum',
          EnumValues: new Map([['HELA_ANLAGGNINGSTILLGANGEN', 'Hela anläggningstillgången'], ['ENDAST_INVESTERINGEN', 'Endast investeringen']]),
          EnumSortValues: new Map([['HELA_ANLAGGNINGSTILLGANGEN', 'T'], ['ENDAST_INVESTERINGEN', 'I']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="HELA_ANLAGGNINGSTILLGANGEN=Hela anläggningstillgången;ENDAST_INVESTERINGEN=Endast investeringen"',
          InterfaceType: 'ifChecklist',
        },
        K3Handelse: {
          AttributeName: 'K3Handelse',
          DisplayLabel: 'K3-händelse',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Upprakning: {
          AssociationName: 'Upprakning',
          DisplayLabel: 'Uppräkning',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'ARUpprakning',
          AssociatedComponentName: 'Upprakning',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Tillgang: {
          AssociationName: 'Tillgang',
          DisplayLabel: 'Tillgång',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'ARTillgang',
          AssociatedComponentName: 'Tillgang',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    ARInvesteringsrad: {
      CollectionName: 'ARInvesteringsrad',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Investeringsrad',
        Abstract: true,
        SOLabel: 'Investeringsrad',
        SOGLabel: 'Investeringsrad',
        SBLabel: 'Investeringsraden',
        SBGLabel: 'Investeringsraden',
        POLabel: 'Investeringsrader',
        POGLabel: 'Investeringsrader',
        PBLabel: 'Investeringsraderna',
        PBGLabel: 'Investeringsraderna',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'RegInvrad',
            Abstract: false,
            SOLabel: 'Registrerad investeringsrad',
            SOGLabel: 'Registrerad investeringsrad',
            SBLabel: 'Registrerade investeringsraden',
            SBGLabel: 'Registrerade investeringsraden',
            POLabel: 'Registrerade investeringsrader',
            POGLabel: 'Registrerade investeringsrader',
            PBLabel: 'Registrerade investeringsraderna',
            PBGLabel: 'Registrerade investeringsraderna',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'BokfInvrad',
            Abstract: true,
            SOLabel: 'Bokförd investeringsrad',
            SOGLabel: 'Bokförd investeringsrad',
            SBLabel: 'Bokförda investeringsraden',
            SBGLabel: 'Bokförda investeringsraden',
            POLabel: 'Bokförda investeringsrader',
            POGLabel: 'Bokförda investeringsrader',
            PBLabel: 'Bokförda investeringsraderna',
            PBGLabel: 'Bokförda investeringsraderna',
            Visible: true,
            ChildTypes: [
              {
                TypeValue: 'KontInvrad',
                Abstract: false,
                SOLabel: 'Direktbokförd investeringsrad',
                SOGLabel: 'Direktbokförd investeringsrad',
                SBLabel: 'Direktbokförda investeringsraden',
                SBGLabel: 'Direktbokförda investeringsraden',
                POLabel: 'Direktbokförda investeringsrader',
                POGLabel: 'Direktbokförda investeringsrader',
                PBLabel: 'Direktbokförda investeringsrader',
                PBGLabel: 'Direktbokförda investeringsrader',
                Visible: true,
                ChildTypes: [
                ],
              },
              {
                TypeValue: 'ProjInvrad',
                Abstract: false,
                SOLabel: 'Investeringsrad från projektavslut',
                SOGLabel: 'Investeringsrad från projektavslut',
                SBLabel: 'Investeringsraden från projektavslut',
                SBGLabel: 'Investeringsraden från projektavslut',
                POLabel: 'Investeringsrader från projektavslut',
                POGLabel: 'Investeringsrader från projektavslut',
                PBLabel: 'Investeringsraderna från projektavslut',
                PBGLabel: 'Investeringsraderna från projektavslut',
                Visible: true,
                ChildTypes: [
                ],
              },
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Investeringsraden primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Investeringsraden versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Typ',
          DataType: 'Enum',
          EnumValues: new Map([['REGINVRAD', 'Registrerad investeringsrad'], ['KONTINVRAD', 'Direktbokförd investeringsrad'], ['PROJINVRAD', 'Investeringsrad från projektavslut']]),
          EnumSortValues: new Map([['REGINVRAD', 'R'], ['KONTINVRAD', 'B'], ['PROJINVRAD', 'P']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifTypeTree',
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Investeringsraden id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Investeringsraden fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TILLGANG_ID: {
          AttributeName: 'TILLGANG_ID',
          DisplayLabel: 'Tillgång, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        UPPR_LOPNR: {
          AttributeName: 'UPPR_LOPNR',
          DisplayLabel: 'Uppräkning, löpnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KNYT_DATUM: {
          AttributeName: 'KNYT_DATUM',
          DisplayLabel: 'Datum för knytning',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Knytning',
        },
        KNYT_SIGN: {
          AttributeName: 'KNYT_SIGN',
          DisplayLabel: 'Signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Knytning',
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        BOKF_DATUM: {
          AttributeName: 'BOKF_DATUM',
          DisplayLabel: 'Bokföringsdatum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Reg investeringsrad',
        },
        MANUELL_VER_NR: {
          AttributeName: 'MANUELL_VER_NR',
          DisplayLabel: 'Verifikationsnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Reg investeringsrad',
        },
        KONTOSTRANG: {
          AttributeName: 'KONTOSTRANG',
          DisplayLabel: 'Kontosträng',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNone',
          AttributeGroup: 'Reg investeringsrad',
        },
        LEV_NR: {
          AttributeName: 'LEV_NR',
          DisplayLabel: 'Leverantörsnr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LEV_NAMN: {
          AttributeName: 'LEV_NAMN',
          DisplayLabel: 'Leverantörsnamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FAKTURA_NR: {
          AttributeName: 'FAKTURA_NR',
          DisplayLabel: 'Fakturanummer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Reg investeringsrad',
        },
        KONTERINGSTEXT: {
          AttributeName: 'KONTERINGSTEXT',
          DisplayLabel: 'Konteringstext',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNone',
          AttributeGroup: 'Reg investeringsrad',
        },
        BELOPP: {
          AttributeName: 'BELOPP',
          DisplayLabel: 'Belopp',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONT_BOKF_AR: {
          AttributeName: 'KONT_BOKF_AR',
          DisplayLabel: 'Bokföringsår',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNone',
          AttributeGroup: 'Reg investeringsrad',
        },
        KONT_VER_NR: {
          AttributeName: 'KONT_VER_NR',
          DisplayLabel: 'Ver.nr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONT_LOPNR: {
          AttributeName: 'KONT_LOPNR',
          DisplayLabel: 'Löpnr för kontering',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KPLAN_ID: {
          AttributeName: 'KPLAN_ID',
          DisplayLabel: 'Kontoplan',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_1: {
          AttributeName: 'ORDNINGS_NR_1',
          DisplayLabel: 'Ordningsnr 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_1: {
          AttributeName: 'KONTOID_1',
          DisplayLabel: 'Kontoid 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_2: {
          AttributeName: 'ORDNINGS_NR_2',
          DisplayLabel: 'Ordningsnr 2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_2: {
          AttributeName: 'KONTOID_2',
          DisplayLabel: 'Kontoid 2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_3: {
          AttributeName: 'ORDNINGS_NR_3',
          DisplayLabel: 'Ordningsnr 3',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_3: {
          AttributeName: 'KONTOID_3',
          DisplayLabel: 'Kontoid 3',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_4: {
          AttributeName: 'ORDNINGS_NR_4',
          DisplayLabel: 'Ordningsnr 4',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_4: {
          AttributeName: 'KONTOID_4',
          DisplayLabel: 'Kontoid 4',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_5: {
          AttributeName: 'ORDNINGS_NR_5',
          DisplayLabel: 'Ordningsnr 5',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_5: {
          AttributeName: 'KONTOID_5',
          DisplayLabel: 'Kontoid 5',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_6: {
          AttributeName: 'ORDNINGS_NR_6',
          DisplayLabel: 'Ordningsnr 6',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_6: {
          AttributeName: 'KONTOID_6',
          DisplayLabel: 'Kontoid 6',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_7: {
          AttributeName: 'ORDNINGS_NR_7',
          DisplayLabel: 'Ordningsnr 7',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_7: {
          AttributeName: 'KONTOID_7',
          DisplayLabel: 'Kontoid 7',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_8: {
          AttributeName: 'ORDNINGS_NR_8',
          DisplayLabel: 'Ordningsnr 8',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_8: {
          AttributeName: 'KONTOID_8',
          DisplayLabel: 'Kontoid 8',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_9: {
          AttributeName: 'ORDNINGS_NR_9',
          DisplayLabel: 'Ordningsnr 9',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_9: {
          AttributeName: 'KONTOID_9',
          DisplayLabel: 'Kontoid 9',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_10: {
          AttributeName: 'ORDNINGS_NR_10',
          DisplayLabel: 'Ordningsnr 10',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_10: {
          AttributeName: 'KONTOID_10',
          DisplayLabel: 'Kontoid 10',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Makulerad/Återförd/Skapad/Från aktivering/Från ombokförd påg. investering/Ombokförd investeringsrad/Aktiverad påg. investering/Ombokförd påg. investering/Förbrukningsinventarie',
          DataType: 'Enum',
          EnumValues: new Map([['MAKULERAD', 'Makulerad'], ['ATERFORD', 'Återförd'], ['FRAN_AKTIVERING', 'Från aktivering'], ['FRAN_OMBOKFORD_PAG__INVESTERING', 'Från ombokförd påg. investering'], ['OMBOKFORD_INVESTERINGSRAD', 'Ombokförd investeringsrad'], ['AKTIVERAD_PAG__INVESTERING', 'Aktiverad påg. investering'], ['OMBOKFORD_PAG__INVESTERING', 'Ombokförd påg. investering'], ['FORBRUKNINGSINVENTARIE', 'Förbrukningsinventarie']]),
          EnumSortValues: new Map([['MAKULERAD', 'M'], ['ATERFORD', 'S'], ['FRAN_AKTIVERING', 'A'], ['FRAN_OMBOKFORD_PAG__INVESTERING', 'K'], ['OMBOKFORD_INVESTERINGSRAD', 'O'], ['AKTIVERAD_PAG__INVESTERING', '1'], ['OMBOKFORD_PAG__INVESTERING', '2'], ['FORBRUKNINGSINVENTARIE', 'F']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="MAKULERAD=Makulerad;ATERFORD=Återförd;FRAN_AKTIVERING=Från aktivering;FRAN_OMBOKFORD_PAG__INVESTERING=Från ombokförd påg. investering;OMBOKFORD_INVESTERINGSRAD=Ombokförd investeringsrad;AKTIVERAD_PAG__INVESTERING=Aktiverad påg. investering;OMBOKFORD_PAG__INVESTERING=Ombokförd påg. investering;FORBRUKNINGSINVENTARIE=Förbrukningsinventarie"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
        },
        STATUS_DATUM: {
          AttributeName: 'STATUS_DATUM',
          DisplayLabel: 'Status, datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        AnlaggningsNr: {
          AttributeName: 'AnlaggningsNr',
          DisplayLabel: 'Anläggningsnummer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AnlaggningsBen: {
          AttributeName: 'AnlaggningsBen',
          DisplayLabel: 'Anläggningsbenämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        xAnlaggningsAnlGrupp: {
          AttributeName: 'xAnlaggningsAnlGrupp',
          DisplayLabel: 'Anläggningens grupp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        xAnlaggningsAnlGruppID: {
          AttributeName: 'xAnlaggningsAnlGruppID',
          DisplayLabel: 'Anläggningens grupp ID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BokfDatum: {
          AttributeName: 'BokfDatum',
          DisplayLabel: 'Bokföringsdatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        Vernr: {
          AttributeName: 'Vernr',
          DisplayLabel: 'Verifikationsnr',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        BokfBelopp: {
          AttributeName: 'BokfBelopp',
          DisplayLabel: 'Bokfört belopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        BokfFakturanr: {
          AttributeName: 'BokfFakturanr',
          DisplayLabel: 'Fakturanummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        BokfLevnr: {
          AttributeName: 'BokfLevnr',
          DisplayLabel: 'Leverantörsnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        Knuten: {
          AttributeName: 'Knuten',
          DisplayLabel: 'Knuten till anl tillgång',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Knytning',
        },
        xcalcTillgangId: {
          AttributeName: 'xcalcTillgangId',
          DisplayLabel: 'calcTillgangId',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BokfLevNamn: {
          AttributeName: 'BokfLevNamn',
          DisplayLabel: 'Leverantör, namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        BokfKontText: {
          AttributeName: 'BokfKontText',
          DisplayLabel: 'Konteringstext',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        INVRAD_ID: {
          AttributeName: 'INVRAD_ID',
          DisplayLabel: 'Ref till investeringsrad',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfInvrad'],
        },
        LevNr: {
          AttributeName: 'LevNr',
          DisplayLabel: 'Leverantörsnr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfInvrad'],
        },
        LevNamn: {
          AttributeName: 'LevNamn',
          DisplayLabel: 'Leverantörsnamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfInvrad'],
        },
        FaktNr: {
          AttributeName: 'FaktNr',
          DisplayLabel: 'Fakturanummer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfInvrad'],
        },
        Bokf_Ar_Bokf: {
          AttributeName: 'Bokf_Ar_Bokf',
          DisplayLabel: 'Bokföringsår',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfInvrad'],
        },
        KontoId_1_Bokf: {
          AttributeName: 'KontoId_1_Bokf',
          DisplayLabel: 'KontoId_1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfInvrad'],
        },
        KontoId_2_Bokf: {
          AttributeName: 'KontoId_2_Bokf',
          DisplayLabel: 'KontoId_2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfInvrad'],
        },
        KontoId_3_Bokf: {
          AttributeName: 'KontoId_3_Bokf',
          DisplayLabel: 'KontoId_3',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfInvrad'],
        },
        KontoId_4_Bokf: {
          AttributeName: 'KontoId_4_Bokf',
          DisplayLabel: 'KontoId_4',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfInvrad'],
        },
        KontoId_5_Bokf: {
          AttributeName: 'KontoId_5_Bokf',
          DisplayLabel: 'KontoId_5',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfInvrad'],
        },
        KontoId_6_Bokf: {
          AttributeName: 'KontoId_6_Bokf',
          DisplayLabel: 'KontoId_6',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfInvrad'],
        },
        KontoId_7_Bokf: {
          AttributeName: 'KontoId_7_Bokf',
          DisplayLabel: 'KontoId_7',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfInvrad'],
        },
        KontoId_8_Bokf: {
          AttributeName: 'KontoId_8_Bokf',
          DisplayLabel: 'KontoId_8',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfInvrad'],
        },
        KontoId_9_Bokf: {
          AttributeName: 'KontoId_9_Bokf',
          DisplayLabel: 'KontoId_9',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfInvrad'],
        },
        KontoId_10_Bokf: {
          AttributeName: 'KontoId_10_Bokf',
          DisplayLabel: 'KontoId_10',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfInvrad'],
        },
        KontoStr: {
          AttributeName: 'KontoStr',
          DisplayLabel: 'Kontosträng',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['BokfInvrad'],
        },
        KontoBen: {
          AttributeName: 'KontoBen',
          DisplayLabel: 'Kontobenamning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfInvrad'],
        },
        VerText: {
          AttributeName: 'VerText',
          DisplayLabel: 'Verifikationstext',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['BokfInvrad'],
        },
        xDefBokf: {
          AttributeName: 'xDefBokf',
          DisplayLabel: 'Definitivbokförd',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfInvrad'],
        },
        Leverantor: {
          AttributeName: 'Leverantor',
          DisplayLabel: 'Leverantör',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfInvrad'],
        },
        SortKontostr: {
          AttributeName: 'SortKontostr',
          DisplayLabel: 'SortKontostr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['BokfInvrad'],
        },
        InvestKonto_del1: {
          AttributeName: 'InvestKonto_del1',
          DisplayLabel: '@KONTO1@, investeringskonto',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['BokfInvrad'],
        },
        InvestKonto_del2: {
          AttributeName: 'InvestKonto_del2',
          DisplayLabel: '@KONTO2@, investeringskonto',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['BokfInvrad'],
        },
        InvestKonto_del3: {
          AttributeName: 'InvestKonto_del3',
          DisplayLabel: '@KONTO3@, investeringskonto',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['BokfInvrad'],
        },
        InvestKonto_del4: {
          AttributeName: 'InvestKonto_del4',
          DisplayLabel: '@KONTO4@, investeringskonto',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['BokfInvrad'],
        },
        InvestKonto_del5: {
          AttributeName: 'InvestKonto_del5',
          DisplayLabel: '@KONTO5@, investeringskonto',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['BokfInvrad'],
        },
        InvestKonto_del6: {
          AttributeName: 'InvestKonto_del6',
          DisplayLabel: '@KONTO6@, investeringskonto',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['BokfInvrad'],
        },
        InvestKonto_del7: {
          AttributeName: 'InvestKonto_del7',
          DisplayLabel: '@KONTO7@, investeringskonto',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['BokfInvrad'],
        },
        InvestKonto_del8: {
          AttributeName: 'InvestKonto_del8',
          DisplayLabel: '@KONTO8@, investeringskonto',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['BokfInvrad'],
        },
        InvestKonto_del9: {
          AttributeName: 'InvestKonto_del9',
          DisplayLabel: '@KONTO9@, investeringskonto',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['BokfInvrad'],
        },
        InvestKonto_del10: {
          AttributeName: 'InvestKonto_del10',
          DisplayLabel: '@KONTO10@, investeringskonto',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['BokfInvrad'],
        },
        URSPR_BOKF_AR: {
          AttributeName: 'URSPR_BOKF_AR',
          DisplayLabel: 'URSPR_BOKF_AR',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDateYear',
          ValidInComps: ['BokfInvrad'],
        },
        URSPR_VER_NR: {
          AttributeName: 'URSPR_VER_NR',
          DisplayLabel: 'URSPR_VER_NR',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfInvrad'],
        },
        Aktiverad: {
          AttributeName: 'Aktiverad',
          DisplayLabel: 'Aktiverad',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          InterfaceType: 'ifBoolean',
          ValidInComps: ['BokfInvrad'],
        },
        K3Handelse: {
          AttributeName: 'K3Handelse',
          DisplayLabel: 'H3-händelse',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        HarTillaggsinfo: {
          AttributeName: 'HarTillaggsinfo',
          DisplayLabel: 'Har tilläggsinfo',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        TillaggInvBen: {
          AttributeName: 'TillaggInvBen',
          DisplayLabel: 'Tillägg, komponent/investering',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Tilläggsinfo',
        },
        TillaggKomponenttyp: {
          AttributeName: 'TillaggKomponenttyp',
          DisplayLabel: 'Tillägg, komponenttyp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Tilläggsinfo',
        },
        TillaggAvskrTid: {
          AttributeName: 'TillaggAvskrTid',
          DisplayLabel: 'Tillägg, avskrivningstid',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Tilläggsinfo',
        },
        TillaggDatum: {
          AttributeName: 'TillaggDatum',
          DisplayLabel: 'Tillägg, datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Tilläggsinfo',
        },
        TillaggNy: {
          AttributeName: 'TillaggNy',
          DisplayLabel: 'Tillägg, ny anl.tillg',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Tilläggsinfo',
        },
        TillaggTillgang: {
          AttributeName: 'TillaggTillgang',
          DisplayLabel: 'Tillägg, anl.tillgång',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Tilläggsinfo',
        },
        TillaggOmrade: {
          AttributeName: 'TillaggOmrade',
          DisplayLabel: 'Tillägg, område',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Tilläggsinfo',
        },
        TillaggKommentar: {
          AttributeName: 'TillaggKommentar',
          DisplayLabel: 'Tilläggsinfo, kommentar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Tilläggsinfo',
        },
        TillaggAvskrkonto: {
          AttributeName: 'TillaggAvskrkonto',
          DisplayLabel: 'Tilläggsinfo, avskrivs på',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Tilläggsinfo',
        },
        TillaggOmradeId: {
          AttributeName: 'TillaggOmradeId',
          DisplayLabel: 'Tillägg, område id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TillaggTillgangId: {
          AttributeName: 'TillaggTillgangId',
          DisplayLabel: 'Tillägg, anl tillgång id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Liststring: {
          AttributeName: 'Liststring',
          DisplayLabel: 'Liststring',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Tillgang: {
          AssociationName: 'Tillgang',
          DisplayLabel: 'Tillgång',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'ARTillgang',
          AssociatedComponentName: 'Tillgang',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontering: {
          AssociationName: 'Kontering',
          DisplayLabel: 'Kontering',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKBokfkontering',
          AssociatedComponentName: 'BokfKontering',
          JoinAssociation: true,
          ValidInComps: ['BokfInvrad'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        BokfVer: {
          AssociationName: 'BokfVer',
          DisplayLabel: 'Verifikationer',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKBokfver',
          AssociatedComponentName: 'BokfVer',
          JoinAssociation: true,
          ValidInComps: ['BokfInvrad'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Investering: {
          AssociationName: 'Investering',
          DisplayLabel: 'Investering',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARUpprakning',
          AssociatedComponentName: 'Investering',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Konteringsforslag: {
          AssociationName: 'Konteringsforslag',
          DisplayLabel: 'Konteringsförslag/tilläggsinfo',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRKonteringsForslag',
          AssociatedComponentName: 'KonteringsForslag',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    ARKomponent: {
      CollectionName: 'ARKomponent',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['AllowSelection', '17003']]),
      RootType: {
        TypeValue: 'Komponent',
        Abstract: false,
        SOLabel: 'Komponenttyp',
        SOGLabel: 'Komponenttyps',
        SBLabel: 'Komponenttypen',
        SBGLabel: 'Komponenttypens',
        POLabel: 'Komponenttyper',
        POGLabel: 'Komponenttypers',
        PBLabel: 'Komponenttyperna',
        PBGLabel: 'Komponenttypernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Komponenttypens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Komponenttypens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Komponenttypens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Komponenttypens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        AKTIV: {
          AttributeName: 'AKTIV',
          DisplayLabel: 'Aktiv',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        Standard: {
          AttributeName: 'Standard',
          DisplayLabel: 'Standard komponenttyp',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    ARPlats: {
      CollectionName: 'ARPlats',
      UDAEnabled: true,
      UDNEnabled: false,
      Properties: new Map([['AllowSelection', '17003']]),
      RootType: {
        TypeValue: 'Plats',
        Abstract: true,
        SOLabel: 'Område/Byggnad/Rum',
        SOGLabel: 'Område/Byggnad/Rum',
        SBLabel: 'Området/Byggnaden/Rummmet',
        SBGLabel: 'Området/Byggnaden/Rummmet',
        POLabel: 'Område/Byggnader/Rum',
        POGLabel: 'Område/Byggnader/Rum',
        PBLabel: 'Områdena/Byggnadena/Rummmen',
        PBGLabel: 'Områdena/Byggnadena/Rummmen',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'Omrade',
            Abstract: false,
            SOLabel: 'Område',
            SOGLabel: 'Område',
            SBLabel: 'Området',
            SBGLabel: 'Området',
            POLabel: 'Områden',
            POGLabel: 'Områden',
            PBLabel: 'Områdena',
            PBGLabel: 'Områdena',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'Byggnad',
            Abstract: false,
            SOLabel: 'Byggnad',
            SOGLabel: 'Byggnad',
            SBLabel: 'Byggnaden',
            SBGLabel: 'Byggnaden',
            POLabel: 'Byggnader',
            POGLabel: 'Byggnader',
            PBLabel: 'Byggnaderna',
            PBGLabel: 'Byggnaderna',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'Rum',
            Abstract: false,
            SOLabel: 'Rum',
            SOGLabel: 'Rum',
            SBLabel: 'Rummet',
            SBGLabel: 'Rummet',
            POLabel: 'Rummen',
            POGLabel: 'Rummen',
            PBLabel: 'Rummen',
            PBGLabel: 'Rummen',
            Visible: true,
            ChildTypes: [
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Området/Byggnaden/Rummmet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Området/Byggnaden/Rummmet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Typ av plats',
          DataType: 'Enum',
          EnumValues: new Map([['OMRADE', 'Område'], ['BYGGNAD', 'Byggnad'], ['RUM', 'Rum']]),
          EnumSortValues: new Map([['OMRADE', 'F'], ['BYGGNAD', 'B'], ['RUM', 'R']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="OMRADE=Område;BYGGNAD=Byggnad;RUM=Rum"',
          GUIEditable: true,
          InterfaceType: 'ifTypeTree',
          Required: true,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Området/Byggnaden/Rummmet id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Området/Byggnaden/Rummmet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 40,
          Properties: new Map([['ConditionShowValues', 'True;']]),
          Required: true,
        },
        FINNS_I_PLATS: {
          AttributeName: 'FINNS_I_PLATS',
          DisplayLabel: 'Finns i plats',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PLATS_KOD: {
          AttributeName: 'PLATS_KOD',
          DisplayLabel: 'Nummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 20,
          Properties: new Map([['ConditionShowValues', 'True;']]),
        },
        Kod: {
          AttributeName: 'Kod',
          DisplayLabel: 'Kod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        KodBenamning2: {
          AttributeName: 'KodBenamning2',
          DisplayLabel: 'Kod och benämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        xFastighetskod: {
          AttributeName: 'xFastighetskod',
          DisplayLabel: 'Områdeskod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        KodBenamning: {
          AttributeName: 'KodBenamning',
          DisplayLabel: 'Kod och benämning',
          Hint: 'Kan användas för att söka på alla tillgångar/inventarier i ett område, bygggnad och/eller rum',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True;']]),
        },
        KBAvskrKontoKred: {
          AttributeName: 'KBAvskrKontoKred',
          DisplayLabel: 'KBAvskrKontoKred',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KBAvskrKontoDeb: {
          AttributeName: 'KBAvskrKontoDeb',
          DisplayLabel: 'KBAvskrKontoDeb',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KBInternRantaDeb: {
          AttributeName: 'KBInternRantaDeb',
          DisplayLabel: 'KBInternRantaDeb',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KBInternRantaKred: {
          AttributeName: 'KBInternRantaKred',
          DisplayLabel: 'KBInternRantaKred',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AvskrKontoKred: {
          AttributeName: 'AvskrKontoKred',
          DisplayLabel: 'Konteringsmall - Avskrivning kredit',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        AvskrKontoDeb: {
          AttributeName: 'AvskrKontoDeb',
          DisplayLabel: 'Konteringsmall - Avskrivning debet',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        InternRantaDeb: {
          AttributeName: 'InternRantaDeb',
          DisplayLabel: 'Konteringsmall - Internränta debet',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        InternRantaKred: {
          AttributeName: 'InternRantaKred',
          DisplayLabel: 'Konteringsmall - Internränta kredit',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        ByggnadId: {
          AttributeName: 'ByggnadId',
          DisplayLabel: 'ByggnadId',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
        },
        OmradeId: {
          AttributeName: 'OmradeId',
          DisplayLabel: 'OmradeId',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
        },
        OmradeBen: {
          AttributeName: 'OmradeBen',
          DisplayLabel: 'Område',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RuleID: {
          AttributeName: 'RuleID',
          DisplayLabel: 'RuleID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANLGRUPP_ID: {
          AttributeName: 'ANLGRUPP_ID',
          DisplayLabel: 'Anl. grupp Id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Omrade'],
        },
        ANVANDS_I_AR: {
          AttributeName: 'ANVANDS_I_AR',
          DisplayLabel: 'Används i Anläggningsredovisning',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          ValidInComps: ['Omrade'],
        },
        ANVANDS_I_EK: {
          AttributeName: 'ANVANDS_I_EK',
          DisplayLabel: 'Används för gåvor',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          FormatterParseParams: 'FalseText="Nej";TrueText="Ja"',
          FormatterDisplayParams: 'FalseText="Nej";TrueText="Ja"',
          GUIEditable: true,
          ValidInComps: ['Omrade'],
        },
        Anlaggningsgrupp: {
          AttributeName: 'Anlaggningsgrupp',
          DisplayLabel: 'Anläggningsgrupp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Omrade'],
        },
        OmradeKod: {
          AttributeName: 'OmradeKod',
          DisplayLabel: 'Område, kod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['ConditionShowValues', 'True;']]),
        },
        OmradeKodBen: {
          AttributeName: 'OmradeKodBen',
          DisplayLabel: 'Område, kod och benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['ConditionShowValues', 'True;']]),
        },
        ByggnadKodBen: {
          AttributeName: 'ByggnadKodBen',
          DisplayLabel: 'Byggnad, kod och benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['ConditionShowValues', 'True;']]),
        },
        ByggnadKod: {
          AttributeName: 'ByggnadKod',
          DisplayLabel: 'Byggnad, kod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['ConditionShowValues', 'True;']]),
        },
        ByggnadBen: {
          AttributeName: 'ByggnadBen',
          DisplayLabel: 'Byggnad, benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        RumKodBen: {
          AttributeName: 'RumKodBen',
          DisplayLabel: 'Rum, kod och benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['ConditionShowValues', 'True;']]),
        },
        RumKod: {
          AttributeName: 'RumKod',
          DisplayLabel: 'Rum, kod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['ConditionShowValues', 'True;']]),
        },
        RumBen: {
          AttributeName: 'RumBen',
          DisplayLabel: 'Rum, benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        FASTIGHETSBETECKNING: {
          AttributeName: 'FASTIGHETSBETECKNING',
          DisplayLabel: 'Fastighetsbeteckning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          ValidInComps: ['Byggnad'],
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        AKTIV: {
          AttributeName: 'AKTIV',
          DisplayLabel: 'Akriv',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        IsAktiv: {
          AttributeName: 'IsAktiv',
          DisplayLabel: 'Är aktiv',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        FASTIGHETSNUMMER: {
          AttributeName: 'FASTIGHETSNUMMER',
          DisplayLabel: 'Fastighetsnummer',
          Hint: 'Fastighetsnummer enligt fastighetssystem',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FASTIGHETSTYP: {
          AttributeName: 'FASTIGHETSTYP',
          DisplayLabel: 'Fastighetstyp',
          Hint: 'Administrationsbyggnad/Andaktsrum/Begravningsplats/Bisättningsrum/Bostadshus/Bygdegård/Bystuga/Bårhus/Ceremonirum/ceremonihall/Cykelparkering/Flerbostadshus/Friggebod/Förrådsbyggnad/Församlingshem/Förskolebyggnad/Garage/Gravkor/Mausoleum/Hotell/Jordbruksmark/Jordkällare/Klockstapel/Kolumbarium/Krematorium/Kursgård/Kyrka/kapell/Kyrkogårdsmur/Kyrkorum/kyrksal/kapellrum/Kyrkstuga/Kyrktomt/Källsorteringshus/Lekplats/Lekstuga/Lägergård/Museum/Omkopplingsstation/Ordenslokal/Parkeringsplats/Parkmark/Personalbyggnad/Prästgård/Radiomast/Restaurang/Samlingslokal/Skogsmark/Skolbyggnad/Skolgård/Skorstensanläggning/Skyddsbyggnad/Skärmtak/Stiftsgård/Teknikbod/Toalett/Trädgård/Vaktmästeri/Vandrarhem/Vatten/Verkstad/Växthus',
          DataType: 'Enum',
          EnumValues: new Map([['ADMINISTRATIONSBYGGNAD', 'Administrationsbyggnad'], ['ANDAKTSRUM', 'Andaktsrum'], ['BEGRAVNINGSPLATS', 'Begravningsplats'], ['BISATTNINGSRUM', 'Bisättningsrum'], ['BOSTADSHUS', 'Bostadshus'], ['BYGDEGARD_BYSTUGA', 'Bygdegård/Bystuga'], ['BARHUS', 'Bårhus'], ['CEREMONIRUM_CEREMONIHALL', 'Ceremonirum/ceremonihall'], ['CYKELPARKERING', 'Cykelparkering'], ['FLERBOSTADSHUS', 'Flerbostadshus'], ['FRIGGEBOD', 'Friggebod'], ['FORRADSBYGGNAD', 'Förrådsbyggnad'], ['FORSAMLINGSHEM', 'Församlingshem'], ['FORSKOLEBYGGNAD', 'Förskolebyggnad'], ['GARAGE', 'Garage'], ['GRAVKOR_MAUSOLEUM', 'Gravkor/Mausoleum'], ['HOTELL', 'Hotell'], ['JORDBRUKSMARK', 'Jordbruksmark'], ['JORDKALLARE', 'Jordkällare'], ['KLOCKSTAPEL', 'Klockstapel'], ['KOLUMBARIUM', 'Kolumbarium'], ['KREMATORIUM', 'Krematorium'], ['KURSGARD', 'Kursgård'], ['KYRKA_KAPELL', 'Kyrka/kapell'], ['KYRKOGARDSMUR', 'Kyrkogårdsmur'], ['KYRKORUM_KYRKSAL_KAPELLRUM', 'Kyrkorum/kyrksal/kapellrum'], ['KYRKSTUGA', 'Kyrkstuga'], ['KYRKTOMT', 'Kyrktomt'], ['KALLSORTERINGSHUS', 'Källsorteringshus'], ['LEKPLATS', 'Lekplats'], ['LEKSTUGA', 'Lekstuga'], ['LAGERGARD', 'Lägergård'], ['MUSEUM', 'Museum'], ['OMKOPPLINGSSTATION', 'Omkopplingsstation'], ['ORDENSLOKAL', 'Ordenslokal'], ['PARKERINGSPLATS', 'Parkeringsplats'], ['PARKMARK', 'Parkmark'], ['PERSONALBYGGNAD', 'Personalbyggnad'], ['PRASTGARD', 'Prästgård'], ['RADIOMAST', 'Radiomast'], ['RESTAURANG', 'Restaurang'], ['SAMLINGSLOKAL', 'Samlingslokal'], ['SKOGSMARK', 'Skogsmark'], ['SKOLBYGGNAD', 'Skolbyggnad'], ['SKOLGARD', 'Skolgård'], ['SKORSTENSANLAGGNING', 'Skorstensanläggning'], ['SKYDDSBYGGNAD', 'Skyddsbyggnad'], ['SKARMTAK', 'Skärmtak'], ['STIFTSGARD', 'Stiftsgård'], ['TEKNIKBOD', 'Teknikbod'], ['TOALETT', 'Toalett'], ['TRADGARD', 'Trädgård'], ['VAKTMASTERI', 'Vaktmästeri'], ['VANDRARHEM', 'Vandrarhem'], ['VATTEN', 'Vatten'], ['VERKSTAD', 'Verkstad'], ['VAXTHUS', 'Växthus']]),
          EnumSortValues: new Map([['ADMINISTRATIONSBYGGNAD', 'AEA'], ['ANDAKTSRUM', 'BED01'], ['BEGRAVNINGSPLATS', 'DCE'], ['BISATTNINGSRUM', 'BED04'], ['BOSTADSHUS', 'AAA02'], ['BYGDEGARD_BYSTUGA', 'ANB03'], ['BARHUS', 'APE01'], ['CEREMONIRUM_CEREMONIHALL', 'BED03'], ['CYKELPARKERING', 'CCA'], ['FLERBOSTADSHUS', 'AAB'], ['FRIGGEBOD', 'AKA'], ['FORRADSBYGGNAD', 'APA'], ['FORSAMLINGSHEM', 'ANB01'], ['FORSKOLEBYGGNAD', 'AHA'], ['GARAGE', 'APB02'], ['GRAVKOR_MAUSOLEUM', 'APF02'], ['HOTELL', 'ABA'], ['JORDBRUKSMARK', 'DDE'], ['JORDKALLARE', 'APA02'], ['KLOCKSTAPEL', 'BBJ'], ['KOLUMBARIUM', 'APF03'], ['KREMATORIUM', 'BFD'], ['KURSGARD', 'AHD'], ['KYRKA_KAPELL', 'AND01'], ['KYRKOGARDSMUR', 'RUA'], ['KYRKORUM_KYRKSAL_KAPELLRUM', 'BED02'], ['KYRKSTUGA', 'AAA03'], ['KYRKTOMT', 'BEE'], ['KALLSORTERINGSHUS', 'APC'], ['LEKPLATS', 'DEF'], ['LEKSTUGA', 'AKG'], ['LAGERGARD', 'ABB1'], ['MUSEUM', 'AMC'], ['OMKOPPLINGSSTATION', 'BBE'], ['ORDENSLOKAL', 'AND04'], ['PARKERINGSPLATS', 'CCB'], ['PARKMARK', 'DBB'], ['PERSONALBYGGNAD', 'ANF'], ['PRASTGARD', 'AAA01'], ['RADIOMAST', 'BBA'], ['RESTAURANG', 'ABC'], ['SAMLINGSLOKAL', 'ANB02'], ['SKOGSMARK', 'DDD'], ['SKOLBYGGNAD', 'AHB'], ['SKOLGARD', 'DCD'], ['SKORSTENSANLAGGNING', 'BCA'], ['SKYDDSBYGGNAD', 'ADA'], ['SKARMTAK', 'AKF'], ['STIFTSGARD', 'BFF'], ['TEKNIKBOD', 'BBF'], ['TOALETT', 'ACA'], ['TRADGARD', 'DBA'], ['VAKTMASTERI', 'AFB01'], ['VANDRARHEM', 'ABB2'], ['VATTEN', 'GCD'], ['VERKSTAD', 'AFB02'], ['VAXTHUS', 'AKE']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ADMINISTRATIONSBYGGNAD=Administrationsbyggnad;ANDAKTSRUM=Andaktsrum;BEGRAVNINGSPLATS=Begravningsplats;BISATTNINGSRUM=Bisättningsrum;BOSTADSHUS=Bostadshus;BYGDEGARD_BYSTUGA=Bygdegård/Bystuga;BARHUS=Bårhus;CEREMONIRUM_CEREMONIHALL=Ceremonirum/ceremonihall;CYKELPARKERING=Cykelparkering;FLERBOSTADSHUS=Flerbostadshus;FRIGGEBOD=Friggebod;FORRADSBYGGNAD=Förrådsbyggnad;FORSAMLINGSHEM=Församlingshem;FORSKOLEBYGGNAD=Förskolebyggnad;GARAGE=Garage;GRAVKOR_MAUSOLEUM=Gravkor/Mausoleum;HOTELL=Hotell;JORDBRUKSMARK=Jordbruksmark;JORDKALLARE=Jordkällare;KLOCKSTAPEL=Klockstapel;KOLUMBARIUM=Kolumbarium;KREMATORIUM=Krematorium;KURSGARD=Kursgård;KYRKA_KAPELL=Kyrka/kapell;KYRKOGARDSMUR=Kyrkogårdsmur;KYRKORUM_KYRKSAL_KAPELLRUM=Kyrkorum/kyrksal/kapellrum;KYRKSTUGA=Kyrkstuga;KYRKTOMT=Kyrktomt;KALLSORTERINGSHUS=Källsorteringshus;LEKPLATS=Lekplats;LEKSTUGA=Lekstuga;LAGERGARD=Lägergård;MUSEUM=Museum;OMKOPPLINGSSTATION=Omkopplingsstation;ORDENSLOKAL=Ordenslokal;PARKERINGSPLATS=Parkeringsplats;PARKMARK=Parkmark;PERSONALBYGGNAD=Personalbyggnad;PRASTGARD=Prästgård;RADIOMAST=Radiomast;RESTAURANG=Restaurang;SAMLINGSLOKAL=Samlingslokal;SKOGSMARK=Skogsmark;SKOLBYGGNAD=Skolbyggnad;SKOLGARD=Skolgård;SKORSTENSANLAGGNING=Skorstensanläggning;SKYDDSBYGGNAD=Skyddsbyggnad;SKARMTAK=Skärmtak;STIFTSGARD=Stiftsgård;TEKNIKBOD=Teknikbod;TOALETT=Toalett;TRADGARD=Trädgård;VAKTMASTERI=Vaktmästeri;VANDRARHEM=Vandrarhem;VATTEN=Vatten;VERKSTAD=Verkstad;VAXTHUS=Växthus"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FastighetsnrKodBenamning: {
          AttributeName: 'FastighetsnrKodBenamning',
          DisplayLabel: 'Fastighetsnr och kod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Blob: {
          AssociationName: 'Blob',
          DisplayLabel: 'Blob',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'ARPlatsBlob',
          AssociatedComponentName: 'PlatsBlob',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: true,
          Properties: new Map([]),
        },
        Plats: {
          AssociationName: 'Plats',
          DisplayLabel: 'Ingår i plats',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'ARPlats',
          AssociatedComponentName: 'Plats',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        AnlGrupp: {
          AssociationName: 'AnlGrupp',
          DisplayLabel: 'Anläggningsgrupp',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARAnlGrupp',
          AssociatedComponentName: 'AnlGrupp',
          JoinAssociation: true,
          ValidInComps: ['Omrade'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Tillgangar: {
          AssociationName: 'Tillgangar',
          DisplayLabel: 'Anläggningstillgangar/Inventarier',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'ARTillgang',
          AssociatedComponentName: 'Tillgang',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        AvskrkontoKred: {
          AssociationName: 'AvskrkontoKred',
          DisplayLabel: 'Avskrivningskonto, kredit',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        AvskrkontoDeb: {
          AssociationName: 'AvskrkontoDeb',
          DisplayLabel: 'Avskrivningskonto debet',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        InternRantaDeb: {
          AssociationName: 'InternRantaDeb',
          DisplayLabel: 'Konto för internränta debet',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        InternRantaKred: {
          AssociationName: 'InternRantaKred',
          DisplayLabel: 'Konto för internränta kredit',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    ARPlatsBlob: {
      CollectionName: 'ARPlatsBlob',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'PlatsBlob',
        Abstract: false,
        SOLabel: '',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: '',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'ARPlatsBlobs primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'ARPlatsBlobs versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'ARPlatsBlobs id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'ARPlatsBlobs fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BESKRIVNING: {
          AttributeName: 'BESKRIVNING',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    ARRubrikAnlKat: {
      CollectionName: 'ARRubrikAnlKat',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'RubrikAnlKat',
        Abstract: false,
        SOLabel: 'Rubrik anläggningskategori',
        SOGLabel: 'Rubrik anläggningskategori',
        SBLabel: 'Rubrik anläggningskategorien',
        SBGLabel: 'Rubrik anläggningskategorien',
        POLabel: 'Rubrik anläggningskategorier',
        POGLabel: 'Rubrik anläggningskategorier',
        PBLabel: 'Rubrik anläggningskategorierna',
        PBGLabel: 'Rubrik anläggningskategorierna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Rubrik anläggningskategorien primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Rubrik anläggningskategorien versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Rubrik anläggningskategorien id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Rubrik anläggningskategorien fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RUBRIK_ID: {
          AttributeName: 'RUBRIK_ID',
          DisplayLabel: 'Rubrik Id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        ANLKAT_ID: {
          AttributeName: 'ANLKAT_ID',
          DisplayLabel: 'Anl.kategori Id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    ARRubrik: {
      CollectionName: 'ARRubrik',
      UDAEnabled: true,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '3002']]),
      RootType: {
        TypeValue: 'Rubrik',
        Abstract: false,
        SOLabel: 'Rubrik',
        SOGLabel: 'Rubrik',
        SBLabel: 'Rubriken',
        SBGLabel: 'Rubriken',
        POLabel: 'Rubriker',
        POGLabel: 'Rubriker',
        PBLabel: 'Rubrikerna',
        PBGLabel: 'Rubrikerna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Rubriken primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Rubriken versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Rubriken id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Rubriken fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AR_RUBRIK_ID: {
          AttributeName: 'AR_RUBRIK_ID',
          DisplayLabel: 'Kod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True;']]),
          Required: true,
        },
        HUVUDRUBRIK_ID: {
          AttributeName: 'HUVUDRUBRIK_ID',
          DisplayLabel: 'Huvudrubrik',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        ANLAGGNINGSTYP: {
          AttributeName: 'ANLAGGNINGSTYP',
          DisplayLabel: 'Anläggningstyp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ConditionShowValues', 'True;']]),
          Required: true,
        },
        SKATTEMASSIG: {
          AttributeName: 'SKATTEMASSIG',
          DisplayLabel: 'Hantera skattemässiga värden',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        KBAvskrKontoKred: {
          AttributeName: 'KBAvskrKontoKred',
          DisplayLabel: 'KBAvskrKontoKred',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ConstantValue', '-6;']]),
        },
        AvskrKontoKred: {
          AttributeName: 'AvskrKontoKred',
          DisplayLabel: 'Konteringsmall - Avskrivning kredit',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        KBAvskrKontoDeb: {
          AttributeName: 'KBAvskrKontoDeb',
          DisplayLabel: 'KBAvskrKontoDeb',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ConstantValue', '-79;']]),
        },
        AvskrKontoDeb: {
          AttributeName: 'AvskrKontoDeb',
          DisplayLabel: 'Konteringsmall - Avskrivning debet',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        KBInternRantaDeb: {
          AttributeName: 'KBInternRantaDeb',
          DisplayLabel: 'KBInternRantaDeb',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ConstantValue', '-80;']]),
        },
        InternRantaDeb: {
          AttributeName: 'InternRantaDeb',
          DisplayLabel: 'Konteringsmall - Internränta debet',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        KBInternRantaKred: {
          AttributeName: 'KBInternRantaKred',
          DisplayLabel: 'KBInternRantaKred',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ConstantValue', '-81;']]),
        },
        InternRantaKred: {
          AttributeName: 'InternRantaKred',
          DisplayLabel: 'Konteringsmall - Internränta kredit',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        KodBenamning: {
          AttributeName: 'KodBenamning',
          DisplayLabel: 'Rubrik',
          Hint: 'Rubrik på formen kod : benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        RuleID: {
          AttributeName: 'RuleID',
          DisplayLabel: 'RuleID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AKTIV: {
          AttributeName: 'AKTIV',
          DisplayLabel: 'Aktiv',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RubrikIdInvKonto: {
          AttributeName: 'RubrikIdInvKonto',
          DisplayLabel: 'RubrikIdInvKonto',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Blob: {
          AssociationName: 'Blob',
          DisplayLabel: 'Blob',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'ARRubrikBlob',
          AssociatedComponentName: 'RubrikBlob',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: true,
          Properties: new Map([]),
        },
        AvskrkontoKred: {
          AssociationName: 'AvskrkontoKred',
          DisplayLabel: 'Avskrivningskonto kredit',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        AvskrkontoDeb: {
          AssociationName: 'AvskrkontoDeb',
          DisplayLabel: 'Avskrivningskonto debet',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        InternRantaDeb: {
          AssociationName: 'InternRantaDeb',
          DisplayLabel: 'Konto för internränta debet',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        InternRantaKred: {
          AssociationName: 'InternRantaKred',
          DisplayLabel: 'Konto för internränta kredit',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        HuvudRubrik: {
          AssociationName: 'HuvudRubrik',
          DisplayLabel: 'Huvudrubrik',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARHuvudRubrik',
          AssociatedComponentName: 'HuvudRubrik',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Tillgangar: {
          AssociationName: 'Tillgangar',
          DisplayLabel: 'Anläggningstillgångar/Inventarier',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'ARTillgang',
          AssociatedComponentName: 'Tillgang',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        SkatteRestvarde: {
          AssociationName: 'SkatteRestvarde',
          DisplayLabel: 'Skattemässiga restvärden',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'ARRubrikSkatt',
          AssociatedComponentName: 'RubrikSkatt',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        AnlKategorier: {
          AssociationName: 'AnlKategorier',
          DisplayLabel: 'Rubrikens anl.kategorier',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'ARRubrikAnlKat',
          AssociatedComponentName: 'RubrikAnlKat',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        UrvalInvradRub: {
          AssociationName: 'UrvalInvradRub',
          DisplayLabel: 'Urval, inv.rader',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'ARRubrikInvUrval',
          AssociatedComponentName: 'RubrikInvUrval',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    ARRubrikBlob: {
      CollectionName: 'ARRubrikBlob',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'RubrikBlob',
        Abstract: false,
        SOLabel: '',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: '',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'ARRubrikBlobs primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'ARRubrikBlobs versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'ARRubrikBlobs id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'ARRubrikBlobs fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BESKRIVNING: {
          AttributeName: 'BESKRIVNING',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    ARSKVAvrakning: {
      CollectionName: 'ARSKVAvrakning',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'SKVAvrakning',
        Abstract: true,
        SOLabel: 'Skattemässig investeringshändelse',
        SOGLabel: 'Skattemässig investeringshändelses',
        SBLabel: 'Skattemässiga investeringshändelsen',
        SBGLabel: 'Skattemässiga investeringshändelsens',
        POLabel: 'Skattemässiga investeringshändelser',
        POGLabel: 'Skattemässiga investeringshändelsers',
        PBLabel: 'Skattemässiga investeringshändelserna',
        PBGLabel: 'Skattemässiga investeringshändelsernas',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'SKVAvskrivning',
            Abstract: true,
            SOLabel: 'Skattemässig avskrivning',
            SOGLabel: 'Skattemässig avskrivnings',
            SBLabel: 'Skattemässiga avskrivningen',
            SBGLabel: 'Skattemässiga avskrivningens',
            POLabel: 'Skattemässiga avskrivningar',
            POGLabel: 'Skattemässiga avskrivningars',
            PBLabel: 'Skattemässiga avskrivningarna',
            PBGLabel: 'Skattemässiga avskrivningarnas',
            Visible: true,
            ChildTypes: [
              {
                TypeValue: 'SKVNormalAvskr',
                Abstract: false,
                SOLabel: 'Sparad skattemässig avskrivning',
                SOGLabel: 'Sparad skattemässig avskrivnings',
                SBLabel: 'Sparade skattemässiga avskrivningen',
                SBGLabel: 'Sparada skattemässiga avskrivningens',
                POLabel: 'Sparade skattemässiga avskrivningar',
                POGLabel: 'Sparade skattemässiga avskrivningars',
                PBLabel: 'Sparade skattemässiga avskrivningarna',
                PBGLabel: 'Sparade skattemässiga avskrivningarnas',
                Visible: true,
                ChildTypes: [
                ],
              },
              {
                TypeValue: 'SKVRegAvskr',
                Abstract: false,
                SOLabel: 'Registrerad skattemässig avskrivning',
                SOGLabel: 'Registrerad skattemässig avskrivnings',
                SBLabel: 'Registrerade skattemässiga avskrivningen',
                SBGLabel: 'Registrerade skattemässiga avskrivningens',
                POLabel: 'Registrerade skattemässiga avskrivningar',
                POGLabel: 'Registrerade skattemässiga avskrivningars',
                PBLabel: 'Registrerade skattemässiga avskrivningarna',
                PBGLabel: 'Registrerade skattemässiga avskrivningarnas',
                Visible: true,
                ChildTypes: [
                ],
              },
            ],
          },
          {
            TypeValue: 'SKVRegNedskr',
            Abstract: false,
            SOLabel: 'Skattemässig nedskrivning',
            SOGLabel: 'Skattemässig nedskrivning',
            SBLabel: 'Skattemässig nedskrivning',
            SBGLabel: 'Skattemässig nedskrivning',
            POLabel: 'Skattemässig nedskrivning',
            POGLabel: 'Skattemässig nedskrivning',
            PBLabel: 'Skattemässig nedskrivning',
            PBGLabel: 'Skattemässig nedskrivning',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'SKVRegAvyttr',
            Abstract: false,
            SOLabel: 'Skattemässig avyttring',
            SOGLabel: 'Skattemässig avyttring',
            SBLabel: 'Skattemässig avyttring',
            SBGLabel: 'Skattemässig avyttring',
            POLabel: 'Skattemässig avyttring',
            POGLabel: 'Skattemässig avyttring',
            PBLabel: 'Skattemässig avyttring',
            PBGLabel: 'Skattemässig avyttring',
            Visible: false,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'SKVRegUtrang',
            Abstract: false,
            SOLabel: 'Skattemässig utrangering',
            SOGLabel: 'Skattemässig utrangering',
            SBLabel: 'Skattemässig utrangering',
            SBGLabel: 'Skattemässig utrangering',
            POLabel: 'Skattemässig utrangering',
            POGLabel: 'Skattemässig utrangering',
            PBLabel: 'Skattemässig utrangering',
            PBGLabel: 'Skattemässig utrangering',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'SKVRegKorrigering',
            Abstract: false,
            SOLabel: 'Skattemässig korrigering',
            SOGLabel: 'Skattemässig korrigerings',
            SBLabel: 'Skattemässiga korrigeringen',
            SBGLabel: 'Skattemässiga korrigeringens',
            POLabel: 'Skattemässiga korrigeringar',
            POGLabel: 'Skattemässiga korrigeringar',
            PBLabel: 'Skattemässiga korrigeringarna',
            PBGLabel: 'Skattemässiga korrigeringarnas',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'SKVDelning',
            Abstract: false,
            SOLabel: 'Avskiljd investering',
            SOGLabel: 'Avskiljd investerings',
            SBLabel: 'Avskiljda investeringen',
            SBGLabel: 'Avskiljda investeringens',
            POLabel: 'Avskiljda investeringar',
            POGLabel: 'Avskiljda investeringars',
            PBLabel: 'Avskiljda investeringarna',
            PBGLabel: 'Avskiljda investeringarnas',
            Visible: true,
            ChildTypes: [
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Skattemässiga investeringshändelsens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Skattemässiga investeringshändelsens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Typ',
          DataType: 'Enum',
          EnumValues: new Map([['SKVNORMALAVSKR', 'Sparad skattemässig avskrivning'], ['SKVREGAVSKR', 'Registrerad skattemässig avskrivning'], ['SKVREGNEDSKR', 'Skattemässig nedskrivning'], ['SKVREGAVYTTR', 'Skattemässig avyttring'], ['SKVREGUTRANG', 'Skattemässig utrangering'], ['SKVREGKORRIGERING', 'Skattemässig korrigering'], ['SKVDELNING', 'Avskiljd investering']]),
          EnumSortValues: new Map([['SKVNORMALAVSKR', 'A'], ['SKVREGAVSKR', 'R'], ['SKVREGNEDSKR', 'N'], ['SKVREGAVYTTR', 'Y'], ['SKVREGUTRANG', 'U'], ['SKVREGKORRIGERING', 'K'], ['SKVDELNING', 'D']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifTypeTree',
          Required: true,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Skattemässiga investeringshändelsens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Skattemässiga investeringshändelsens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BELOPP: {
          AttributeName: 'BELOPP',
          DisplayLabel: 'Belopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        FROM_DATUM: {
          AttributeName: 'FROM_DATUM',
          DisplayLabel: 'Fr o m datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TOM_DATUM: {
          AttributeName: 'TOM_DATUM',
          DisplayLabel: 'T o m datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        AVYTTR_UTRANG_TYP: {
          AttributeName: 'AVYTTR_UTRANG_TYP',
          DisplayLabel: 'Avyttringstyp',
          Hint: 'Hela anläggningstillgången/Endast investeringen',
          DataType: 'Enum',
          EnumValues: new Map([['HELA_ANLAGGNINGSTILLGANGEN', 'Hela anläggningstillgången'], ['ENDAST_INVESTERINGEN', 'Endast investeringen']]),
          EnumSortValues: new Map([['HELA_ANLAGGNINGSTILLGANGEN', 'T'], ['ENDAST_INVESTERINGEN', 'I']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="HELA_ANLAGGNINGSTILLGANGEN=Hela anläggningstillgången;ENDAST_INVESTERINGEN=Endast investeringen"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        AVSKRDIFF: {
          AttributeName: 'AVSKRDIFF',
          DisplayLabel: 'Avskrivningsdiff',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NOTERING: {
          AttributeName: 'NOTERING',
          DisplayLabel: 'Notering',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        JUST_AVSKR_BELOPP: {
          AttributeName: 'JUST_AVSKR_BELOPP',
          DisplayLabel: 'Justering avskrivningsbelopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        JUST_INV_BELOPP: {
          AttributeName: 'JUST_INV_BELOPP',
          DisplayLabel: 'Justering, investeringsbelopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Upprakning: {
          AssociationName: 'Upprakning',
          DisplayLabel: 'Investering',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARUpprakning',
          AssociatedComponentName: 'Upprakning',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    ARRubrikSkatt: {
      CollectionName: 'ARRubrikSkatt',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'Y']]),
      RootType: {
        TypeValue: 'RubrikSkatt',
        Abstract: false,
        SOLabel: 'Skattemässiga restvärde',
        SOGLabel: 'Skattemässiga restvärde',
        SBLabel: 'Skattemässiga restvärdet',
        SBGLabel: 'Skattemässiga restvärdet',
        POLabel: 'Skattemässiga restvärden',
        POGLabel: 'Skattemässiga restvärden',
        PBLabel: 'Skattemässiga restvärdena',
        PBGLabel: 'Skattemässiga restvärdena',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Skattemässiga restvärdet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Skattemässiga restvärdet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Skattemässiga restvärdet id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Skattemässiga restvärdet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AR_RUBRIK_ID: {
          AttributeName: 'AR_RUBRIK_ID',
          DisplayLabel: 'AR_RUBRIK_ID',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        BOKF_AR: {
          AttributeName: 'BOKF_AR',
          DisplayLabel: 'Bokföringsår',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDateYear',
        },
        ING_RESTVARDE: {
          AttributeName: 'ING_RESTVARDE',
          DisplayLabel: 'Ingående skattemässigt restvärde',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        INKOP: {
          AttributeName: 'INKOP',
          DisplayLabel: 'Årets inköp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        FORSALJNING: {
          AttributeName: 'FORSALJNING',
          DisplayLabel: 'Årets försäljning',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        UTG_RESTVARDE: {
          AttributeName: 'UTG_RESTVARDE',
          DisplayLabel: 'Utgående skattemässigt restvärde',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        SKATTEREGEL: {
          AttributeName: 'SKATTEREGEL',
          DisplayLabel: 'Skatteregel',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 1,
        },
        Skatteregel_Benamning: {
          AttributeName: 'Skatteregel_Benamning',
          DisplayLabel: 'Skatteregel benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Avskrivning: {
          AttributeName: 'Avskrivning',
          DisplayLabel: 'Avskrvining',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Rubrik: {
          AssociationName: 'Rubrik',
          DisplayLabel: 'Rubrik',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'ARRubrik',
          AssociatedComponentName: 'Rubrik',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    ARInvesteringSkatt: {
      CollectionName: 'ARInvesteringSkatt',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'Y']]),
      RootType: {
        TypeValue: 'InvesteringSkatt',
        Abstract: false,
        SOLabel: 'Skattemässigt restvärde för investering',
        SOGLabel: 'Skattemässigt restvärde för investering',
        SBLabel: 'Skattemässiga restvärdet för investering',
        SBGLabel: 'Skattemässiga restvärdet för investering',
        POLabel: 'Skattemässiga restvärden för investering',
        POGLabel: 'Skattemässiga restvärden för investering',
        PBLabel: 'Skattemässiga restvärdena för investering',
        PBGLabel: 'Skattemässiga restvärdena för investering',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Skattemässiga restvärdet för investering primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Skattemässiga restvärdet för investering versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Skattemässiga restvärdet för investering id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Skattemässiga restvärdet för investering fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        UPPR_LOPNR: {
          AttributeName: 'UPPR_LOPNR',
          DisplayLabel: 'Löpnr',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        BOKF_AR: {
          AttributeName: 'BOKF_AR',
          DisplayLabel: 'Bokföringsår',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDateYear',
        },
        ING_RESTVARDE: {
          AttributeName: 'ING_RESTVARDE',
          DisplayLabel: 'Ingående restvärde',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        INKOP: {
          AttributeName: 'INKOP',
          DisplayLabel: 'Inköp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        FORSALJNING: {
          AttributeName: 'FORSALJNING',
          DisplayLabel: 'Försäljning',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        UTG_RESTVARDE: {
          AttributeName: 'UTG_RESTVARDE',
          DisplayLabel: 'Utgående restvärde',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        INKOPS_AR: {
          AttributeName: 'INKOPS_AR',
          DisplayLabel: 'Inköpsår',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDateYear',
          GUIEditable: true,
        },
        PROCENT_SATS: {
          AttributeName: 'PROCENT_SATS',
          DisplayLabel: 'Procentsats',
          DataType: 'Float',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Investering: {
          AssociationName: 'Investering',
          DisplayLabel: 'Investering',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'ARUpprakning',
          AssociatedComponentName: 'Investering',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Tillgang: {
          AssociationName: 'Tillgang',
          DisplayLabel: 'Tillgång',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'ARTillgang',
          AssociatedComponentName: 'Tillgang',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    ARAnlGruppInvUrval: {
      CollectionName: 'ARAnlGruppInvUrval',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'AnlGruppInvUrval',
        Abstract: false,
        SOLabel: 'Urval investeringsrader',
        SOGLabel: 'Urval investeringsrader',
        SBLabel: 'Urvalet av investeringsrader',
        SBGLabel: 'Urvalet av investeringsrader',
        POLabel: 'Urval investeringsrader',
        POGLabel: 'Urval investeringsrader',
        PBLabel: 'Urval investeringsrader',
        PBGLabel: 'Urval investeringsrader',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Urvalet av investeringsrader primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Urvalet av investeringsrader versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Urvalet av investeringsrader id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Urvalet av investeringsrader fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KPLAN_ID: {
          AttributeName: 'KPLAN_ID',
          DisplayLabel: 'Kontoplan, id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        ANLGRUPP_ID: {
          AttributeName: 'ANLGRUPP_ID',
          DisplayLabel: 'Anläggningsgrupp, id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        VIEW_ID: {
          AttributeName: 'VIEW_ID',
          DisplayLabel: 'Urval, id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        INTRANTA_URVAL: {
          AttributeName: 'INTRANTA_URVAL',
          DisplayLabel: 'Internränta, urvalsprincip',
          Hint: 'Endast begr.verksamhet och skattepliktig verksamhet/Beräkna internränta på allt/Beräkna inte internränta/Ange urval vid beräkning/Ange urval i förväg',
          DataType: 'Enum',
          EnumValues: new Map([['ENDAST_BEGR_VERKSAMHET_OCH_SKATTEPLIKTIG_VERKSAMHET', 'Endast begr.verksamhet och skattepliktig verksamhet'], ['BERAKNA_INTERNRANTA_PA_ALLT', 'Beräkna internränta på allt'], ['BERAKNA_INTE_INTERNRANTA', 'Beräkna inte internränta'], ['ANGE_URVAL_VID_BERAKNING', 'Ange urval vid beräkning'], ['ANGE_URVAL_I_FORVAG', 'Ange urval i förväg']]),
          EnumSortValues: new Map([['ENDAST_BEGR_VERKSAMHET_OCH_SKATTEPLIKTIG_VERKSAMHET', 'B'], ['BERAKNA_INTERNRANTA_PA_ALLT', 'T'], ['BERAKNA_INTE_INTERNRANTA', 'E'], ['ANGE_URVAL_VID_BERAKNING', 'A'], ['ANGE_URVAL_I_FORVAG', 'G']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ENDAST_BEGR_VERKSAMHET_OCH_SKATTEPLIKTIG_VERKSAMHET=Endast begr.verksamhet och skattepliktig verksamhet;BERAKNA_INTERNRANTA_PA_ALLT=Beräkna internränta på allt;BERAKNA_INTE_INTERNRANTA=Beräkna inte internränta;ANGE_URVAL_VID_BERAKNING=Ange urval vid beräkning;ANGE_URVAL_I_FORVAG=Ange urval i förväg"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        INTRANTA_VIEW_ID: {
          AttributeName: 'INTRANTA_VIEW_ID',
          DisplayLabel: 'Internränta, urval id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    ARRubrikInvUrval: {
      CollectionName: 'ARRubrikInvUrval',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'RubrikInvUrval',
        Abstract: false,
        SOLabel: 'Urval invrader, rubrik',
        SOGLabel: 'Urval invrader, rubrik',
        SBLabel: 'Urvalet invrader, rubrik',
        SBGLabel: 'Urvalet invrader, rubrik',
        POLabel: 'Urval invrader, rubrik',
        POGLabel: 'Urval invrader, rubrik',
        PBLabel: 'Urvalen invrader, rubrik',
        PBGLabel: 'Urvalen invrader, rubrik',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Urvalet invrader, rubrik primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Urvalet invrader, rubrik versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Urvalet invrader, rubrik fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VIEW_ID: {
          AttributeName: 'VIEW_ID',
          DisplayLabel: 'Urval, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    ARVerksamhetskod: {
      CollectionName: 'ARVerksamhetskod',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Verksamhetskod',
        Abstract: false,
        SOLabel: 'Verksamhetskod',
        SOGLabel: 'Verksamhetskod',
        SBLabel: 'Verksamhetskoden',
        SBGLabel: 'Verksamhetskoden',
        POLabel: 'Verksamhetskoder',
        POGLabel: 'Verksamhetskoder',
        PBLabel: 'Verksamhetskoderna',
        PBGLabel: 'Verksamhetskoderna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Verksamhetskoden primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Verksamhetskoden versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Verksamhetskoden id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Verksamhetskoden fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KOD: {
          AttributeName: 'KOD',
          DisplayLabel: 'Verksamhetskod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['ConditionShowValues', 'True;']]),
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ConditionShowValues', 'True;']]),
        },
        KBAvskrKontoKred: {
          AttributeName: 'KBAvskrKontoKred',
          DisplayLabel: 'KBAvskrKontoKred',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KBAvskrKontoDeb: {
          AttributeName: 'KBAvskrKontoDeb',
          DisplayLabel: 'KBAvskrKontoDeb',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KBInternRantaDeb: {
          AttributeName: 'KBInternRantaDeb',
          DisplayLabel: 'KBInternRantaDeb',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KBInternRantaKred: {
          AttributeName: 'KBInternRantaKred',
          DisplayLabel: 'KBInternRantaKred',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AvskrKontoKred: {
          AttributeName: 'AvskrKontoKred',
          DisplayLabel: 'Konteringsmall - Avskrivning kredit',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        AvskrKontoDeb: {
          AttributeName: 'AvskrKontoDeb',
          DisplayLabel: 'Konteringsmall - Avskrivning debet',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        InternRantaDeb: {
          AttributeName: 'InternRantaDeb',
          DisplayLabel: 'Konteringsmall - Internränta debet',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        InternRantaKred: {
          AttributeName: 'InternRantaKred',
          DisplayLabel: 'Konteringsmall - Internränta kredit',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        KodBenamning: {
          AttributeName: 'KodBenamning',
          DisplayLabel: 'Kod och benämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RuleID: {
          AttributeName: 'RuleID',
          DisplayLabel: 'RuleID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        AvskrkontoKred: {
          AssociationName: 'AvskrkontoKred',
          DisplayLabel: 'Avskrivningskonto kredit',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        AvskrkontoDeb: {
          AssociationName: 'AvskrkontoDeb',
          DisplayLabel: 'Avskrivningskonto debet',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        InternRantaDeb: {
          AssociationName: 'InternRantaDeb',
          DisplayLabel: 'Konto för internränta debet',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        InternRantaKred: {
          AssociationName: 'InternRantaKred',
          DisplayLabel: 'Konto för internränta kredit',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    ARTillgangVardering: {
      CollectionName: 'ARTillgangVardering',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'TillgangVardering',
        Abstract: false,
        SOLabel: 'Värdering',
        SOGLabel: 'Värderings',
        SBLabel: 'Värderingen',
        SBGLabel: 'Värderingens',
        POLabel: 'Värderingar',
        POGLabel: 'Värderingars',
        PBLabel: 'Värderingarna',
        PBGLabel: 'Värderingarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Värderingens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Värderingens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Värderingens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VARDE_DATUM: {
          AttributeName: 'VARDE_DATUM',
          DisplayLabel: 'Värderingsdatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        VARDE: {
          AttributeName: 'VARDE',
          DisplayLabel: 'Värde',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        NOTERING: {
          AttributeName: 'NOTERING',
          DisplayLabel: 'Text',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        USER_ID: {
          AttributeName: 'USER_ID',
          DisplayLabel: 'Användare, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Registreringsdatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KortNotering: {
          AttributeName: 'KortNotering',
          DisplayLabel: 'KortNotering',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Anvandare: {
          AssociationName: 'Anvandare',
          DisplayLabel: 'Användare',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    ARAtgard: {
      CollectionName: 'ARAtgard',
      UDAEnabled: true,
      UDNEnabled: true,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Atgard',
        Abstract: false,
        SOLabel: 'Åtgärd',
        SOGLabel: 'Åtgärd',
        SBLabel: 'Åtgärden',
        SBGLabel: 'Åtgärden',
        POLabel: 'Åtgärder',
        POGLabel: 'Åtgärder',
        PBLabel: 'Åtgärderna',
        PBGLabel: 'Åtgärderna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Åtgärden primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Åtgärden versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Åtgärden id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Åtgärden fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        ATGARDSKOD_ID: {
          AttributeName: 'ATGARDSKOD_ID',
          DisplayLabel: 'Åtgärdskod',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TEXT: {
          AttributeName: 'TEXT',
          DisplayLabel: 'Text',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BELOPP: {
          AttributeName: 'BELOPP',
          DisplayLabel: 'Belopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        xAtgardskodBen: {
          AttributeName: 'xAtgardskodBen',
          DisplayLabel: 'Åtgärdskod',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        sAtgardskod: {
          AttributeName: 'sAtgardskod',
          DisplayLabel: 'Åtgärdskod',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KortText: {
          AttributeName: 'KortText',
          DisplayLabel: 'KortText',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Tillgang: {
          AssociationName: 'Tillgang',
          DisplayLabel: 'Tillgång',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'ARTillgang',
          AssociatedComponentName: 'Tillgang',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Atgardskod: {
          AssociationName: 'Atgardskod',
          DisplayLabel: 'Åtgärdskod',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'ARAtgardskod',
          AssociatedComponentName: 'Atgardskod',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    ARAtgardskod: {
      CollectionName: 'ARAtgardskod',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Atgardskod',
        Abstract: false,
        SOLabel: 'Åtgärdskod',
        SOGLabel: 'Åtgärdskod',
        SBLabel: 'Åtgärdskoden',
        SBGLabel: 'Åtgärdskoden',
        POLabel: 'Åtgärdskoder',
        POGLabel: 'Åtgärdskoder',
        PBLabel: 'Åtgärdskoderna',
        PBGLabel: 'Åtgärdskoderna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Åtgärdskoden primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Åtgärdskoden versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Åtgärdskoden id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Åtgärdskoden fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KOD: {
          AttributeName: 'KOD',
          DisplayLabel: 'Verksamhetskod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['ConditionShowValues', 'True;']]),
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ConditionShowValues', 'True;']]),
        },
        KodBenamning: {
          AttributeName: 'KodBenamning',
          DisplayLabel: 'Kod och benämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        REG_BELOPP: {
          AttributeName: 'REG_BELOPP',
          DisplayLabel: 'Registrera belopp',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
  },
};

export default AR;
